var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStartExam(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 880,
    height: 344,
    viewBox: "0 0 880 344",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{clip-path:url(#i);}.c{fill:url(#a);}.d{clip-path:url(#b);}.e{opacity:0.49;}.f,.h,.n{fill:#fcfffe;}.f,.g{opacity:0.29;}.i{opacity:0.44;}.j{fill:rgba(81,67,158,0.1);}.k{fill:rgba(251,188,5,0.1);}.l{opacity:0.1;}.l,.m{fill:url(#c);}.m{opacity:0.33;}.n{opacity:0.39;}.o{opacity:0.11;}.p{fill:#fff;}.q{fill:#c7cace;}.r{fill:#34a853;}.s{fill:#386fc9;}.t{fill:#4285f4;}.u{fill:#101f37;}.v{opacity:0.35;}.w{fill:#172b4d;}.x{fill:#fcb449;}.y{fill:#dddde0;}.z{fill:#ececf0;}.aa{fill:#b2b3b5;opacity:0.4;}.ab{fill:#eceff2;}.ac{fill:#fdfffe;}.ad{opacity:0.23;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.324,
    y1: 0.448,
    x2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#52e2ca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3fab99"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 880,
    height: 344,
    transform: "translate(0 0)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbbc05",
    stopOpacity: 0.102
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fbbc05"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 880,
    height: 344
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "h",
    className: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "p",
    width: 880,
    height: 344
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-68.39 -61.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 880,
    height: 344,
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "d",
    transform: "translate(68.39 61.12)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "e",
    transform: "translate(-7.873 3.344)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 8.671,
    cy: 8.671,
    r: 8.671
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 7.861,
    cy: 7.861,
    r: 7.861,
    transform: "translate(0.81 24.253)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 7.052,
    cy: 7.052,
    r: 7.052,
    transform: "translate(1.619 48.494)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 6.242,
    cy: 6.242,
    r: 6.242,
    transform: "translate(2.429 72.735)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 5.433,
    cy: 5.433,
    r: 5.433,
    transform: "translate(3.238 96.988)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 4.623,
    cy: 4.623,
    r: 4.623,
    transform: "translate(4.048 121.229)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 3.813,
    cy: 3.813,
    r: 3.813,
    transform: "translate(4.858 145.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M4.141,150.5a3.015,3.015,0,1,0-3,3.015,3,3,0,0,0,3-3.015Z",
    transform: "translate(7.545 22.219)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M3.212,170.322a2.206,2.206,0,1,0-.634,1.571,2.206,2.206,0,0,0,.634-1.571Z",
    transform: "translate(7.665 25.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M2.283,190.208A1.4,1.4,0,1,0,.9,191.592,1.385,1.385,0,0,0,2.283,190.208Z",
    transform: "translate(7.785 29.381)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 8.671,
    cy: 8.671,
    r: 8.671,
    transform: "translate(17.342)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 7.861,
    cy: 7.861,
    r: 7.861,
    transform: "translate(18.151 24.253)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 7.052,
    cy: 7.052,
    r: 7.052,
    transform: "translate(18.961 48.494)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 6.242,
    cy: 6.242,
    r: 6.242,
    transform: "translate(19.771 72.735)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 5.433,
    cy: 5.433,
    r: 5.433,
    transform: "translate(20.58 96.988)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 4.623,
    cy: 4.623,
    r: 4.623,
    transform: "translate(21.39 121.229)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 3.813,
    cy: 3.813,
    r: 3.813,
    transform: "translate(22.199 145.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M18.891,150.5a3,3,0,1,0-.876,2.132A3.015,3.015,0,0,0,18.891,150.5Z",
    transform: "translate(10.102 22.219)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M17.992,170.328a2.206,2.206,0,1,0-2.194,2.194,2.206,2.206,0,0,0,2.194-2.194Z",
    transform: "translate(10.227 25.795)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M17.063,190.208a1.4,1.4,0,1,0-1.385,1.385A1.4,1.4,0,0,0,17.063,190.208Z",
    transform: "translate(10.347 29.381)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 8.671,
    cy: 8.671,
    r: 8.671,
    transform: "translate(34.684)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 7.861,
    cy: 7.861,
    r: 7.861,
    transform: "translate(35.493 24.253)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 7.052,
    cy: 7.052,
    r: 7.052,
    transform: "translate(36.303 48.494)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 6.242,
    cy: 6.242,
    r: 6.242,
    transform: "translate(37.113 72.735)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 5.433,
    cy: 5.433,
    r: 5.433,
    transform: "translate(37.922 96.988)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 4.623,
    cy: 4.623,
    r: 4.623,
    transform: "translate(38.732 121.229)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 3.813,
    cy: 3.813,
    r: 3.813,
    transform: "translate(39.541 145.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M33.7,150.5a3.015,3.015,0,1,0-3.015,3.016A3.015,3.015,0,0,0,33.7,150.5Z",
    transform: "translate(12.669 22.219)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M32.772,170.328a2.206,2.206,0,1,0-2.206,2.194,2.206,2.206,0,0,0,2.206-2.194Z",
    transform: "translate(12.789 25.795)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M31.843,190.208a1.385,1.385,0,1,0-.41.983A1.4,1.4,0,0,0,31.843,190.208Z",
    transform: "translate(12.908 29.381)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 8.671,
    cy: 8.671,
    r: 8.671,
    transform: "translate(52.026)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 7.861,
    cy: 7.861,
    r: 7.861,
    transform: "translate(52.835 24.253)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 7.052,
    cy: 7.052,
    r: 7.052,
    transform: "translate(53.645 48.494)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 6.242,
    cy: 6.242,
    r: 6.242,
    transform: "translate(54.454 72.735)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 5.433,
    cy: 5.433,
    r: 5.433,
    transform: "translate(55.264 96.988)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 4.623,
    cy: 4.623,
    r: 4.623,
    transform: "translate(56.074 121.229)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 3.813,
    cy: 3.813,
    r: 3.813,
    transform: "translate(56.883 145.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M48.467,150.492a3,3,0,1,0-.884,2.14,3,3,0,0,0,.884-2.14Z",
    transform: "translate(15.233 22.223)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M47.542,170.322A2.206,2.206,0,1,0,46.9,171.9,2.206,2.206,0,0,0,47.542,170.322Z",
    transform: "translate(15.349 25.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M46.613,190.208a1.385,1.385,0,1,0-.414.987,1.4,1.4,0,0,0,.414-.987Z",
    transform: "translate(15.469 29.381)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 8.671,
    cy: 8.671,
    r: 8.671,
    transform: "translate(69.356)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 7.861,
    cy: 7.861,
    r: 7.861,
    transform: "translate(70.165 24.253)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 7.052,
    cy: 7.052,
    r: 7.052,
    transform: "translate(70.975 48.494)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 6.242,
    cy: 6.242,
    r: 6.242,
    transform: "translate(71.785 72.735)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 5.433,
    cy: 5.433,
    r: 5.433,
    transform: "translate(72.594 96.988)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 4.623,
    cy: 4.623,
    r: 4.623,
    transform: "translate(73.404 121.229)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 3.813,
    cy: 3.813,
    r: 3.813,
    transform: "translate(74.213 145.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M63.251,150.5a3,3,0,1,0-.876,2.132A3.015,3.015,0,0,0,63.251,150.5Z",
    transform: "translate(17.791 22.219)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M62.322,170.328a2.206,2.206,0,1,0-2.194,2.194,2.206,2.206,0,0,0,2.194-2.194Z",
    transform: "translate(17.911 25.795)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M61.413,190.208a1.4,1.4,0,1,0-1.385,1.385A1.4,1.4,0,0,0,61.413,190.208Z",
    transform: "translate(18.034 29.381)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 8.671,
    cy: 8.671,
    r: 8.671,
    transform: "translate(86.698)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 7.861,
    cy: 7.861,
    r: 7.861,
    transform: "translate(87.507 24.253)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 7.052,
    cy: 7.052,
    r: 7.052,
    transform: "translate(88.317 48.494)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 6.242,
    cy: 6.242,
    r: 6.242,
    transform: "translate(89.126 72.735)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 5.433,
    cy: 5.433,
    r: 5.433,
    transform: "translate(89.936 96.988)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 4.623,
    cy: 4.623,
    r: 4.623,
    transform: "translate(90.746 121.229)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 3.813,
    cy: 3.813,
    r: 3.813,
    transform: "translate(91.555 145.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M78.031,150.5a3.015,3.015,0,1,0-3.015,3.016,3.015,3.015,0,0,0,3.015-3.016Z",
    transform: "translate(20.353 22.219)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M77.1,170.328a2.206,2.206,0,1,0-2.206,2.194,2.206,2.206,0,0,0,2.206-2.194Z",
    transform: "translate(20.473 25.795)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M76.173,190.208a1.385,1.385,0,1,0-.41.983A1.4,1.4,0,0,0,76.173,190.208Z",
    transform: "translate(20.592 29.381)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 8.671,
    cy: 8.671,
    r: 8.671,
    transform: "translate(104.039)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 7.861,
    cy: 7.861,
    r: 7.861,
    transform: "translate(104.849 24.253)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 7.052,
    cy: 7.052,
    r: 7.052,
    transform: "translate(105.659 48.494)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 6.242,
    cy: 6.242,
    r: 6.242,
    transform: "translate(106.468 72.735)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 5.433,
    cy: 5.433,
    r: 5.433,
    transform: "translate(107.278 96.988)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 4.623,
    cy: 4.623,
    r: 4.623,
    transform: "translate(108.087 121.229)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 3.813,
    cy: 3.813,
    r: 3.813,
    transform: "translate(108.897 145.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M92.8,150.492a3,3,0,1,0-.876,2.132,3,3,0,0,0,.876-2.132Z",
    transform: "translate(22.917 22.223)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M91.872,170.328a2.206,2.206,0,1,0-2.194,2.194,2.206,2.206,0,0,0,2.194-2.194Z",
    transform: "translate(23.033 25.795)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M90.943,190.208a1.4,1.4,0,1,0-1.385,1.385,1.4,1.4,0,0,0,1.385-1.385Z",
    transform: "translate(23.152 29.381)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 8.671,
    cy: 8.671,
    r: 8.671,
    transform: "translate(121.37)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 7.861,
    cy: 7.861,
    r: 7.861,
    transform: "translate(122.179 24.253)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 7.052,
    cy: 7.052,
    r: 7.052,
    transform: "translate(122.989 48.494)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 6.242,
    cy: 6.242,
    r: 6.242,
    transform: "translate(123.798 72.735)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 5.433,
    cy: 5.433,
    r: 5.433,
    transform: "translate(124.608 96.988)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 4.623,
    cy: 4.623,
    r: 4.623,
    transform: "translate(125.418 121.229)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 3.813,
    cy: 3.813,
    r: 3.813,
    transform: "translate(126.227 145.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M107.581,150.5a3,3,0,1,0-.876,2.132,3.015,3.015,0,0,0,.876-2.132Z",
    transform: "translate(25.475 22.219)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M106.652,170.328a2.206,2.206,0,1,0-2.194,2.194,2.206,2.206,0,0,0,2.194-2.194Z",
    transform: "translate(25.595 25.795)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M105.723,190.208a1.4,1.4,0,1,0-1.385,1.385A1.4,1.4,0,0,0,105.723,190.208Z",
    transform: "translate(25.714 29.381)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 8.671,
    cy: 8.671,
    r: 8.671,
    transform: "translate(138.711)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 7.861,
    cy: 7.861,
    r: 7.861,
    transform: "translate(139.521 24.253)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 7.052,
    cy: 7.052,
    r: 7.052,
    transform: "translate(140.331 48.494)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 6.242,
    cy: 6.242,
    r: 6.242,
    transform: "translate(141.14 72.735)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 5.433,
    cy: 5.433,
    r: 5.433,
    transform: "translate(141.95 96.988)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 4.623,
    cy: 4.623,
    r: 4.623,
    transform: "translate(142.759 121.229)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M123.29,130.647a3.813,3.813,0,1,0-1.121,2.7,3.825,3.825,0,0,0,1.121-2.7Z",
    transform: "translate(27.917 18.636)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M122.361,150.5a3.015,3.015,0,1,0-3.015,3.016,3.015,3.015,0,0,0,3.015-3.016Z",
    transform: "translate(28.037 22.219)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M121.432,170.328a2.206,2.206,0,1,0-2.206,2.194,2.206,2.206,0,0,0,2.206-2.194Z",
    transform: "translate(28.156 25.795)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M120.5,190.208a1.385,1.385,0,1,0-.41.983,1.4,1.4,0,0,0,.41-.983Z",
    transform: "translate(28.276 29.381)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 8.671,
    cy: 8.671,
    r: 8.671,
    transform: "translate(156.053)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 7.861,
    cy: 7.861,
    r: 7.861,
    transform: "translate(156.863 24.253)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 7.052,
    cy: 7.052,
    r: 7.052,
    transform: "translate(157.672 48.494)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 6.242,
    cy: 6.242,
    r: 6.242,
    transform: "translate(158.482 72.735)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M139.915,90.933a5.433,5.433,0,1,0-5.433,5.433,5.433,5.433,0,0,0,5.433-5.433Z",
    transform: "translate(30.242 11.476)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M138.986,110.793a4.623,4.623,0,1,0-4.623,4.623,4.623,4.623,0,0,0,4.623-4.623Z",
    transform: "translate(30.361 15.059)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M138.057,130.643a3.8,3.8,0,1,0-1.113,2.7A3.813,3.813,0,0,0,138.057,130.643Z",
    transform: "translate(30.481 18.64)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M137.127,150.492a3,3,0,1,0-.876,2.132A3,3,0,0,0,137.127,150.492Z",
    transform: "translate(30.6 22.223)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M136.2,170.324A2.194,2.194,0,1,0,134,172.518a2.194,2.194,0,0,0,2.194-2.194Z",
    transform: "translate(30.72 25.798)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M135.273,190.208a1.4,1.4,0,1,0-1.385,1.385A1.4,1.4,0,0,0,135.273,190.208Z",
    transform: "translate(30.836 29.381)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 8.671,
    cy: 8.671,
    r: 8.671,
    transform: "translate(173.383)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 7.861,
    cy: 7.861,
    r: 7.861,
    transform: "translate(174.193 24.253)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 7.052,
    cy: 7.052,
    r: 7.052,
    transform: "translate(175.003 48.494)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M155.624,71.082a6.242,6.242,0,1,0-6.242,6.242,6.242,6.242,0,0,0,6.242-6.242Z",
    transform: "translate(32.684 7.895)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M154.7,90.936a5.444,5.444,0,1,0-5.433,5.433,5.444,5.444,0,0,0,5.433-5.433Z",
    transform: "translate(32.8 11.472)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M153.769,110.8a4.635,4.635,0,1,0-4.623,4.623A4.635,4.635,0,0,0,153.769,110.8Z",
    transform: "translate(32.92 15.055)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M152.84,130.647a3.825,3.825,0,1,0-3.813,3.813A3.825,3.825,0,0,0,152.84,130.647Z",
    transform: "translate(33.039 18.636)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M151.891,150.5a3,3,0,1,0-.876,2.132A3.015,3.015,0,0,0,151.891,150.5Z",
    transform: "translate(33.155 22.219)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M150.982,170.328a2.206,2.206,0,1,0-2.194,2.194,2.206,2.206,0,0,0,2.194-2.194Z",
    transform: "translate(33.278 25.795)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M150.053,190.208a1.4,1.4,0,1,0-1.385,1.385A1.4,1.4,0,0,0,150.053,190.208Z",
    transform: "translate(33.398 29.381)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 8.671,
    cy: 8.671,
    r: 8.671,
    transform: "translate(190.725)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 7.861,
    cy: 7.861,
    r: 7.861,
    transform: "translate(191.535 24.253)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M171.32,51.23a7.04,7.04,0,1,0-7.04,7.04,7.04,7.04,0,0,0,7.04-7.04Z",
    transform: "translate(35.128 4.316)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M170.394,71.082a6.242,6.242,0,1,0-6.242,6.242,6.242,6.242,0,0,0,6.242-6.242Z",
    transform: "translate(35.244 7.895)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M169.465,90.933a5.433,5.433,0,1,0-5.433,5.433A5.433,5.433,0,0,0,169.465,90.933Z",
    transform: "translate(35.364 11.476)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M168.536,110.793a4.623,4.623,0,1,0-4.623,4.623,4.623,4.623,0,0,0,4.623-4.623Z",
    transform: "translate(35.483 15.059)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M167.62,130.647a3.813,3.813,0,1,0-1.121,2.7A3.825,3.825,0,0,0,167.62,130.647Z",
    transform: "translate(35.601 18.636)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M166.691,150.5a3.015,3.015,0,1,0-3.015,3.016,3.015,3.015,0,0,0,3.015-3.016Z",
    transform: "translate(35.721 22.219)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M165.762,170.328a2.206,2.206,0,1,0-2.206,2.194,2.206,2.206,0,0,0,2.206-2.194Z",
    transform: "translate(35.84 25.795)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M164.833,190.208a1.385,1.385,0,1,0-.41.983A1.4,1.4,0,0,0,164.833,190.208Z",
    transform: "translate(35.96 29.381)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 8.671,
    cy: 8.671,
    r: 8.671,
    transform: "translate(208.067)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 7.861,
    cy: 7.861,
    r: 7.861,
    transform: "translate(208.877 24.253)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M186.08,51.23a7.04,7.04,0,1,0-7.04,7.04A7.04,7.04,0,0,0,186.08,51.23Z",
    transform: "translate(37.686 4.316)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M185.174,71.082a6.242,6.242,0,1,0-1.832,4.418,6.242,6.242,0,0,0,1.832-4.418Z",
    transform: "translate(37.806 7.895)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M184.245,90.933a5.433,5.433,0,1,0-1.6,3.846,5.433,5.433,0,0,0,1.6-3.846Z",
    transform: "translate(37.926 11.476)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M183.366,110.793a4.623,4.623,0,1,0-4.623,4.623,4.623,4.623,0,0,0,4.623-4.623Z",
    transform: "translate(38.054 15.059)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M182.387,130.643a3.8,3.8,0,1,0-1.113,2.7A3.813,3.813,0,0,0,182.387,130.643Z",
    transform: "translate(38.165 18.64)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M181.457,150.492a3,3,0,1,0-.876,2.132,3,3,0,0,0,.876-2.132Z",
    transform: "translate(38.284 22.223)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M180.528,170.319a2.206,2.206,0,1,0-.638,1.575A2.194,2.194,0,0,0,180.528,170.319Z",
    transform: "translate(38.404 25.804)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M179.6,190.2a1.385,1.385,0,1,0-1.385,1.385A1.385,1.385,0,0,0,179.6,190.2Z",
    transform: "translate(38.524 29.385)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 8.671,
    cy: 8.671,
    r: 8.671,
    transform: "translate(225.397)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 7.861,
    cy: 7.861,
    r: 7.861,
    transform: "translate(226.207 24.253)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 7.052,
    cy: 7.052,
    r: 7.052,
    transform: "translate(227.016 48.494)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M199.954,71.082a6.242,6.242,0,1,0-6.242,6.242A6.242,6.242,0,0,0,199.954,71.082Z",
    transform: "translate(40.368 7.895)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M199.025,90.933a5.433,5.433,0,1,0-5.433,5.433,5.433,5.433,0,0,0,5.433-5.433Z",
    transform: "translate(40.487 11.476)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M198.1,110.8a4.635,4.635,0,1,0-4.623,4.623A4.635,4.635,0,0,0,198.1,110.8Z",
    transform: "translate(40.603 15.055)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M197.13,130.647a3.825,3.825,0,1,0-3.813,3.813A3.825,3.825,0,0,0,197.13,130.647Z",
    transform: "translate(40.716 18.636)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M196.241,150.5a3,3,0,1,0-.876,2.132,3.015,3.015,0,0,0,.876-2.132Z",
    transform: "translate(40.843 22.219)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M195.312,170.328a2.206,2.206,0,1,0-2.194,2.194,2.206,2.206,0,0,0,2.194-2.194Z",
    transform: "translate(40.962 25.795)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M194.413,190.208a1.4,1.4,0,1,0-1.385,1.385,1.4,1.4,0,0,0,1.385-1.385Z",
    transform: "translate(41.087 29.381)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 8.671,
    cy: 8.671,
    r: 8.671,
    transform: "translate(242.739)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 7.861,
    cy: 7.861,
    r: 7.861,
    transform: "translate(243.549 24.253)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 7.052,
    cy: 7.052,
    r: 7.052,
    transform: "translate(244.358 48.494)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 6.242,
    cy: 6.242,
    r: 6.242,
    transform: "translate(245.168 72.735)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M213.8,90.933a5.433,5.433,0,1,0-5.433,5.433A5.433,5.433,0,0,0,213.8,90.933Z",
    transform: "translate(43.048 11.476)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M212.879,110.8a4.635,4.635,0,1,0-4.635,4.623A4.693,4.693,0,0,0,212.879,110.8Z",
    transform: "translate(43.165 15.055)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M211.95,130.647a3.813,3.813,0,1,0-1.121,2.7,3.825,3.825,0,0,0,1.121-2.7Z",
    transform: "translate(43.285 18.636)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M211.021,150.5a3.015,3.015,0,1,0-3.015,3.016,3.015,3.015,0,0,0,3.015-3.016Z",
    transform: "translate(43.405 22.219)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M210.092,170.328a2.206,2.206,0,1,0-2.206,2.194,2.206,2.206,0,0,0,2.206-2.194Z",
    transform: "translate(43.524 25.795)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M209.163,190.208a1.385,1.385,0,1,0-.41.983,1.4,1.4,0,0,0,.41-.983Z",
    transform: "translate(43.644 29.381)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 8.671,
    cy: 8.671,
    r: 8.671,
    transform: "translate(260.081)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 7.861,
    cy: 7.861,
    r: 7.861,
    transform: "translate(260.891 24.253)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 7.052,
    cy: 7.052,
    r: 7.052,
    transform: "translate(261.7 48.494)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 6.242,
    cy: 6.242,
    r: 6.242,
    transform: "translate(262.51 72.735)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 5.433,
    cy: 5.433,
    r: 5.433,
    transform: "translate(263.319 96.988)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 4.623,
    cy: 4.623,
    r: 4.623,
    transform: "translate(264.129 121.229)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M226.717,130.643a3.8,3.8,0,1,0-1.113,2.7,3.813,3.813,0,0,0,1.113-2.7Z",
    transform: "translate(45.849 18.64)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M225.787,150.492a3,3,0,1,0-.876,2.132A3,3,0,0,0,225.787,150.492Z",
    transform: "translate(45.968 22.223)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M224.858,170.324a2.194,2.194,0,1,0-2.194,2.194A2.194,2.194,0,0,0,224.858,170.324Z",
    transform: "translate(46.088 25.798)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M223.929,190.2a1.385,1.385,0,1,0-1.385,1.385,1.385,1.385,0,0,0,1.385-1.385Z",
    transform: "translate(46.207 29.385)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 8.671,
    cy: 8.671,
    r: 8.671,
    transform: "translate(277.411)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 7.861,
    cy: 7.861,
    r: 7.861,
    transform: "translate(278.221 24.253)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 7.052,
    cy: 7.052,
    r: 7.052,
    transform: "translate(279.03 48.494)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 6.242,
    cy: 6.242,
    r: 6.242,
    transform: "translate(279.84 72.735)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 5.433,
    cy: 5.433,
    r: 5.433,
    transform: "translate(280.649 96.988)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 4.623,
    cy: 4.623,
    r: 4.623,
    transform: "translate(281.459 121.229)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 3.813,
    cy: 3.813,
    r: 3.813,
    transform: "translate(282.269 145.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M240.571,150.5a3,3,0,1,0-.876,2.132A3.015,3.015,0,0,0,240.571,150.5Z",
    transform: "translate(48.527 22.219)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M239.652,170.328a2.206,2.206,0,1,0-2.194,2.194,2.206,2.206,0,0,0,2.194-2.194Z",
    transform: "translate(48.648 25.795)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M238.713,190.208a1.4,1.4,0,1,0-1.385,1.385,1.4,1.4,0,0,0,1.385-1.385Z",
    transform: "translate(48.766 29.381)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 8.671,
    cy: 8.671,
    r: 8.671,
    transform: "translate(294.753)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 7.861,
    cy: 7.861,
    r: 7.861,
    transform: "translate(295.563 24.253)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 7.052,
    cy: 7.052,
    r: 7.052,
    transform: "translate(296.372 48.494)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 6.242,
    cy: 6.242,
    r: 6.242,
    transform: "translate(297.182 72.735)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 5.433,
    cy: 5.433,
    r: 5.433,
    transform: "translate(297.991 96.988)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 4.623,
    cy: 4.623,
    r: 4.623,
    transform: "translate(298.801 121.229)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 3.813,
    cy: 3.813,
    r: 3.813,
    transform: "translate(299.611 145.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M255.351,150.5a3.015,3.015,0,1,0-3.015,3.016,3.015,3.015,0,0,0,3.015-3.016Z",
    transform: "translate(51.088 22.219)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M254.422,170.328a2.206,2.206,0,1,0-2.206,2.194,2.206,2.206,0,0,0,2.206-2.194Z",
    transform: "translate(51.208 25.795)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M253.493,190.208a1.385,1.385,0,1,0-.41.983,1.4,1.4,0,0,0,.41-.983Z",
    transform: "translate(51.328 29.381)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 8.671,
    cy: 8.671,
    r: 8.671,
    transform: "translate(312.095)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 7.861,
    cy: 7.861,
    r: 7.861,
    transform: "translate(312.904 24.253)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 7.052,
    cy: 7.052,
    r: 7.052,
    transform: "translate(313.714 48.494)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 6.242,
    cy: 6.242,
    r: 6.242,
    transform: "translate(314.524 72.735)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 5.433,
    cy: 5.433,
    r: 5.433,
    transform: "translate(315.333 96.988)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 4.623,
    cy: 4.623,
    r: 4.623,
    transform: "translate(316.143 121.229)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 3.813,
    cy: 3.813,
    r: 3.813,
    transform: "translate(316.952 145.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M270.117,150.492a3,3,0,1,0-.876,2.132A3,3,0,0,0,270.117,150.492Z",
    transform: "translate(53.652 22.223)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M269.188,170.324a2.194,2.194,0,1,0-2.194,2.194A2.194,2.194,0,0,0,269.188,170.324Z",
    transform: "translate(53.772 25.798)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M268.272,190.208a1.4,1.4,0,1,0-1.4,1.384,1.4,1.4,0,0,0,1.4-1.384Z",
    transform: "translate(53.889 29.381)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 8.671,
    cy: 8.671,
    r: 8.671,
    transform: "translate(329.425)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 7.861,
    cy: 7.861,
    r: 7.861,
    transform: "translate(330.235 24.253)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 7.052,
    cy: 7.052,
    r: 7.052,
    transform: "translate(331.044 48.494)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 6.242,
    cy: 6.242,
    r: 6.242,
    transform: "translate(331.854 72.735)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 5.433,
    cy: 5.433,
    r: 5.433,
    transform: "translate(332.663 96.988)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 4.623,
    cy: 4.623,
    r: 4.623,
    transform: "translate(333.473 121.229)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 3.813,
    cy: 3.813,
    r: 3.813,
    transform: "translate(334.283 145.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M284.891,150.5a3,3,0,1,0-.876,2.132,3.015,3.015,0,0,0,.876-2.132Z",
    transform: "translate(56.209 22.219)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M283.972,170.328a2.206,2.206,0,1,0-2.194,2.194,2.206,2.206,0,0,0,2.194-2.194Z",
    transform: "translate(56.33 25.795)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M283.043,190.208a1.4,1.4,0,1,0-1.385,1.385A1.4,1.4,0,0,0,283.043,190.208Z",
    transform: "translate(56.45 29.381)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 8.671,
    cy: 8.671,
    r: 8.671,
    transform: "translate(346.767)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 7.861,
    cy: 7.861,
    r: 7.861,
    transform: "translate(347.576 24.253)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 7.052,
    cy: 7.052,
    r: 7.052,
    transform: "translate(348.386 48.494)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 6.242,
    cy: 6.242,
    r: 6.242,
    transform: "translate(349.196 72.735)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 5.433,
    cy: 5.433,
    r: 5.433,
    transform: "translate(350.005 96.988)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 4.623,
    cy: 4.623,
    r: 4.623,
    transform: "translate(350.815 121.229)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 3.813,
    cy: 3.813,
    r: 3.813,
    transform: "translate(351.624 145.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M299.681,150.5a3.015,3.015,0,1,0-3.015,3.016,3.015,3.015,0,0,0,3.015-3.016Z",
    transform: "translate(58.772 22.219)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M298.752,170.328a2.206,2.206,0,1,0-2.206,2.194,2.206,2.206,0,0,0,2.206-2.194Z",
    transform: "translate(58.892 25.795)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M297.823,190.208a1.385,1.385,0,1,0-.41.983A1.4,1.4,0,0,0,297.823,190.208Z",
    transform: "translate(59.011 29.381)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 8.671,
    cy: 8.671,
    r: 8.671,
    transform: "translate(364.109)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 7.861,
    cy: 7.861,
    r: 7.861,
    transform: "translate(364.918 24.253)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 7.052,
    cy: 7.052,
    r: 7.052,
    transform: "translate(365.728 48.494)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 6.242,
    cy: 6.242,
    r: 6.242,
    transform: "translate(366.537 72.735)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 5.433,
    cy: 5.433,
    r: 5.433,
    transform: "translate(367.347 96.988)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 4.623,
    cy: 4.623,
    r: 4.623,
    transform: "translate(368.157 121.229)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 3.813,
    cy: 3.813,
    r: 3.813,
    transform: "translate(368.966 145.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M314.447,150.492a3,3,0,1,0-.876,2.132,3,3,0,0,0,.876-2.132Z",
    transform: "translate(61.336 22.223)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M313.532,170.322a2.206,2.206,0,1,0-.638,1.575A2.206,2.206,0,0,0,313.532,170.322Z",
    transform: "translate(61.454 25.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M312.6,190.208a1.385,1.385,0,1,0-.41.983A1.4,1.4,0,0,0,312.6,190.208Z",
    transform: "translate(61.573 29.381)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 8.671,
    cy: 8.671,
    r: 8.671,
    transform: "translate(381.439)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 7.861,
    cy: 7.861,
    r: 7.861,
    transform: "translate(382.248 24.253)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 7.052,
    cy: 7.052,
    r: 7.052,
    transform: "translate(383.058 48.494)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 6.242,
    cy: 6.242,
    r: 6.242,
    transform: "translate(383.868 72.735)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 5.433,
    cy: 5.433,
    r: 5.433,
    transform: "translate(384.677 96.988)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 4.623,
    cy: 4.623,
    r: 4.623,
    transform: "translate(385.487 121.229)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 3.813,
    cy: 3.813,
    r: 3.813,
    transform: "translate(386.296 145.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M329.231,150.5a3,3,0,1,0-.876,2.132,3.015,3.015,0,0,0,.876-2.132Z",
    transform: "translate(63.894 22.219)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M328.3,170.328a2.206,2.206,0,1,0-2.194,2.194,2.206,2.206,0,0,0,2.194-2.194Z",
    transform: "translate(64.014 25.795)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M327.413,190.208a1.4,1.4,0,1,0-1.385,1.385A1.4,1.4,0,0,0,327.413,190.208Z",
    transform: "translate(64.14 29.381)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 8.671,
    cy: 8.671,
    r: 8.671,
    transform: "translate(398.781)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 7.861,
    cy: 7.861,
    r: 7.861,
    transform: "translate(399.59 24.253)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 7.052,
    cy: 7.052,
    r: 7.052,
    transform: "translate(400.4 48.494)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 6.242,
    cy: 6.242,
    r: 6.242,
    transform: "translate(401.209 72.735)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 5.433,
    cy: 5.433,
    r: 5.433,
    transform: "translate(402.019 96.988)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 4.623,
    cy: 4.623,
    r: 4.623,
    transform: "translate(402.829 121.229)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 3.813,
    cy: 3.813,
    r: 3.813,
    transform: "translate(403.638 145.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M344.011,150.5A3.015,3.015,0,1,0,341,153.511a3.015,3.015,0,0,0,3.015-3.016Z",
    transform: "translate(66.456 22.219)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M343.082,170.328a2.206,2.206,0,1,0-2.206,2.194,2.206,2.206,0,0,0,2.206-2.194Z",
    transform: "translate(66.576 25.795)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M342.152,190.208a1.385,1.385,0,1,0-.41.983A1.4,1.4,0,0,0,342.152,190.208Z",
    transform: "translate(66.695 29.381)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 8.671,
    cy: 8.671,
    r: 8.671,
    transform: "translate(416.122)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 7.861,
    cy: 7.861,
    r: 7.861,
    transform: "translate(416.932 24.253)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 7.052,
    cy: 7.052,
    r: 7.052,
    transform: "translate(417.742 48.494)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 6.242,
    cy: 6.242,
    r: 6.242,
    transform: "translate(418.551 72.735)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 5.433,
    cy: 5.433,
    r: 5.433,
    transform: "translate(419.361 96.988)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 4.623,
    cy: 4.623,
    r: 4.623,
    transform: "translate(420.171 121.229)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 3.813,
    cy: 3.813,
    r: 3.813,
    transform: "translate(420.98 145.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M358.777,150.492a3,3,0,1,0-.876,2.132,3,3,0,0,0,.876-2.132Z",
    transform: "translate(69.02 22.223)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M357.862,170.328a2.206,2.206,0,1,0-2.206,2.194,2.206,2.206,0,0,0,2.206-2.194Z",
    transform: "translate(69.138 25.795)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M356.932,190.208a1.385,1.385,0,1,0-.41.983,1.4,1.4,0,0,0,.41-.983Z",
    transform: "translate(69.257 29.381)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 8.671,
    cy: 8.671,
    r: 8.671,
    transform: "translate(433.453)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 7.861,
    cy: 7.861,
    r: 7.861,
    transform: "translate(434.262 24.253)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 7.052,
    cy: 7.052,
    r: 7.052,
    transform: "translate(435.072 48.494)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 6.242,
    cy: 6.242,
    r: 6.242,
    transform: "translate(435.881 72.735)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 5.433,
    cy: 5.433,
    r: 5.433,
    transform: "translate(436.691 96.988)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 4.623,
    cy: 4.623,
    r: 4.623,
    transform: "translate(437.501 121.229)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 3.813,
    cy: 3.813,
    r: 3.813,
    transform: "translate(438.31 145.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M373.561,150.5a3,3,0,1,0-.876,2.132,3.016,3.016,0,0,0,.876-2.132Z",
    transform: "translate(71.578 22.219)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M372.652,170.328a2.206,2.206,0,1,0-2.194,2.194,2.206,2.206,0,0,0,2.194-2.194Z",
    transform: "translate(71.701 25.795)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M371.7,190.208a1.4,1.4,0,1,0-1.385,1.385A1.4,1.4,0,0,0,371.7,190.208Z",
    transform: "translate(71.817 29.381)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 8.671,
    cy: 8.671,
    r: 8.671,
    transform: "translate(450.794)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 7.861,
    cy: 7.861,
    r: 7.861,
    transform: "translate(451.604 24.253)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 7.052,
    cy: 7.052,
    r: 7.052,
    transform: "translate(452.414 48.494)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 6.242,
    cy: 6.242,
    r: 6.242,
    transform: "translate(453.223 72.735)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 5.433,
    cy: 5.433,
    r: 5.433,
    transform: "translate(454.033 96.988)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 4.623,
    cy: 4.623,
    r: 4.623,
    transform: "translate(454.842 121.229)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 3.813,
    cy: 3.813,
    r: 3.813,
    transform: "translate(455.652 145.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M388.341,150.5a3.015,3.015,0,1,0-3.015,3.016,3.015,3.015,0,0,0,3.015-3.016Z",
    transform: "translate(74.14 22.219)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M387.412,170.328a2.206,2.206,0,1,0-2.206,2.194,2.206,2.206,0,0,0,2.206-2.194Z",
    transform: "translate(74.26 25.795)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M386.483,190.208a1.385,1.385,0,1,0-.41.983,1.4,1.4,0,0,0,.41-.983Z",
    transform: "translate(74.379 29.381)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 8.671,
    cy: 8.671,
    r: 8.671,
    transform: "translate(468.136)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 7.861,
    cy: 7.861,
    r: 7.861,
    transform: "translate(468.946 24.253)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 7.052,
    cy: 7.052,
    r: 7.052,
    transform: "translate(469.756 48.494)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 6.242,
    cy: 6.242,
    r: 6.242,
    transform: "translate(470.565 72.735)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 5.433,
    cy: 5.433,
    r: 5.433,
    transform: "translate(471.375 96.988)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 4.623,
    cy: 4.623,
    r: 4.623,
    transform: "translate(472.184 121.229)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 3.813,
    cy: 3.813,
    r: 3.813,
    transform: "translate(472.994 145.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M403.121,150.5a3.015,3.015,0,1,0-3.015,3.016,3.015,3.015,0,0,0,3.015-3.016Z",
    transform: "translate(76.702 22.219)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M402.192,170.328a2.206,2.206,0,1,0-2.206,2.194,2.206,2.206,0,0,0,2.206-2.194Z",
    transform: "translate(76.821 25.795)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M401.263,190.208a1.385,1.385,0,1,0-.41.983,1.4,1.4,0,0,0,.41-.983Z",
    transform: "translate(76.941 29.381)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 8.671,
    cy: 8.671,
    r: 8.671,
    transform: "translate(485.478)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 7.861,
    cy: 7.861,
    r: 7.861,
    transform: "translate(486.288 24.253)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 7.052,
    cy: 7.052,
    r: 7.052,
    transform: "translate(487.097 48.494)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 6.242,
    cy: 6.242,
    r: 6.242,
    transform: "translate(487.907 72.735)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 5.433,
    cy: 5.433,
    r: 5.433,
    transform: "translate(488.717 96.988)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 4.623,
    cy: 4.623,
    r: 4.623,
    transform: "translate(489.526 121.229)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 3.813,
    cy: 3.813,
    r: 3.813,
    transform: "translate(490.336 145.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M417.887,150.492a3,3,0,1,0-.876,2.132,3,3,0,0,0,.876-2.132Z",
    transform: "translate(79.265 22.223)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M416.962,170.328a2.206,2.206,0,1,0-2.194,2.194,2.206,2.206,0,0,0,2.194-2.194Z",
    transform: "translate(79.382 25.795)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M416.033,190.208a1.4,1.4,0,1,0-1.385,1.385,1.4,1.4,0,0,0,1.385-1.385Z",
    transform: "translate(79.501 29.381)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 8.671,
    cy: 8.671,
    r: 8.671,
    transform: "translate(502.808)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 7.861,
    cy: 7.861,
    r: 7.861,
    transform: "translate(503.618 24.253)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 7.052,
    cy: 7.052,
    r: 7.052,
    transform: "translate(504.428 48.494)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 6.242,
    cy: 6.242,
    r: 6.242,
    transform: "translate(505.237 72.735)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 5.433,
    cy: 5.433,
    r: 5.433,
    transform: "translate(506.047 96.988)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 4.623,
    cy: 4.623,
    r: 4.623,
    transform: "translate(506.856 121.229)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M433.6,130.647a3.825,3.825,0,1,0-3.813,3.813,3.825,3.825,0,0,0,3.813-3.813Z",
    transform: "translate(81.704 18.636)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M432.671,150.5a3,3,0,1,0-.876,2.132,3.015,3.015,0,0,0,.876-2.132Z",
    transform: "translate(81.824 22.219)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M431.742,170.328a2.206,2.206,0,1,0-2.194,2.194,2.206,2.206,0,0,0,2.194-2.194Z",
    transform: "translate(81.943 25.795)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M430.813,190.208a1.4,1.4,0,1,0-1.385,1.385,1.4,1.4,0,0,0,1.385-1.385Z",
    transform: "translate(82.063 29.381)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 8.671,
    cy: 8.671,
    r: 8.671,
    transform: "translate(520.15)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 7.861,
    cy: 7.861,
    r: 7.861,
    transform: "translate(520.96 24.253)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 7.052,
    cy: 7.052,
    r: 7.052,
    transform: "translate(521.769 48.494)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 6.242,
    cy: 6.242,
    r: 6.242,
    transform: "translate(522.579 72.735)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 5.433,
    cy: 5.433,
    r: 5.433,
    transform: "translate(523.389 96.988)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M449.3,110.793a4.623,4.623,0,1,0-4.623,4.623,4.623,4.623,0,0,0,4.623-4.623Z",
    transform: "translate(84.148 15.059)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M448.367,130.643a3.8,3.8,0,1,0-1.113,2.7A3.813,3.813,0,0,0,448.367,130.643Z",
    transform: "translate(84.268 18.64)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M447.451,150.5a3.015,3.015,0,1,0-3.016,3.016,3.015,3.015,0,0,0,3.016-3.016Z",
    transform: "translate(84.386 22.219)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M446.522,170.322a2.206,2.206,0,1,0-.634,1.571A2.206,2.206,0,0,0,446.522,170.322Z",
    transform: "translate(84.505 25.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M445.592,190.208a1.385,1.385,0,1,0-.41.983A1.4,1.4,0,0,0,445.592,190.208Z",
    transform: "translate(84.625 29.381)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "g",
    transform: "translate(537.492)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "h",
    cx: 8.671,
    cy: 8.671,
    r: 8.671
  }), /*#__PURE__*/React.createElement("circle", {
    className: "h",
    cx: 7.861,
    cy: 7.861,
    r: 7.861,
    transform: "translate(0.81 24.253)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "h",
    cx: 7.052,
    cy: 7.052,
    r: 7.052,
    transform: "translate(1.619 48.494)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M465.934,71.082a6.242,6.242,0,1,0-6.242,6.242A6.242,6.242,0,0,0,465.934,71.082Z",
    transform: "translate(-451.021 7.895)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M465.005,90.933a5.433,5.433,0,1,0-5.433,5.433A5.433,5.433,0,0,0,465.005,90.933Z",
    transform: "translate(-450.902 11.476)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M464.076,110.793a4.623,4.623,0,1,0-4.623,4.623,4.623,4.623,0,0,0,4.623-4.623Z",
    transform: "translate(-450.782 15.059)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M463.127,130.643a3.8,3.8,0,1,0-1.113,2.7,3.813,3.813,0,0,0,1.113-2.7Z",
    transform: "translate(-450.666 18.64)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M462.217,150.492a3,3,0,1,0-.876,2.132,3,3,0,0,0,.876-2.132Z",
    transform: "translate(-450.543 22.223)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M461.292,170.328a2.206,2.206,0,1,0-2.194,2.194,2.206,2.206,0,0,0,2.194-2.194Z",
    transform: "translate(-450.427 25.795)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M460.413,190.208a1.4,1.4,0,1,0-1.385,1.385,1.4,1.4,0,0,0,1.385-1.385Z",
    transform: "translate(-450.298 29.381)"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 8.671,
    cy: 8.671,
    r: 8.671,
    transform: "translate(554.822)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 7.861,
    cy: 7.861,
    r: 7.861,
    transform: "translate(555.632 24.253)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M481.64,51.23a7.04,7.04,0,1,0-7.04,7.04A7.04,7.04,0,0,0,481.64,51.23Z",
    transform: "translate(88.917 4.316)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M480.714,71.082a6.242,6.242,0,1,0-6.242,6.242A6.242,6.242,0,0,0,480.714,71.082Z",
    transform: "translate(89.033 7.895)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M479.789,90.936a5.444,5.444,0,1,0-5.433,5.433,5.444,5.444,0,0,0,5.433-5.433Z",
    transform: "translate(89.149 11.472)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M478.859,110.8a4.635,4.635,0,1,0-4.623,4.623A4.635,4.635,0,0,0,478.859,110.8Z",
    transform: "translate(89.268 15.055)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M477.93,130.647a3.825,3.825,0,1,0-3.813,3.813,3.825,3.825,0,0,0,3.813-3.813Z",
    transform: "translate(89.388 18.636)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M477,150.5a3,3,0,1,0-.876,2.132A3.015,3.015,0,0,0,477,150.5Z",
    transform: "translate(89.508 22.219)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M476.072,170.328a2.206,2.206,0,1,0-2.194,2.194,2.206,2.206,0,0,0,2.194-2.194Z",
    transform: "translate(89.627 25.795)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M475.143,190.208a1.4,1.4,0,1,0-1.385,1.385A1.4,1.4,0,0,0,475.143,190.208Z",
    transform: "translate(89.747 29.381)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 8.671,
    cy: 8.671,
    r: 8.671,
    transform: "translate(572.164)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 7.861,
    cy: 7.861,
    r: 7.861,
    transform: "translate(572.974 24.253)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M496.41,51.23a7.04,7.04,0,1,0-7.04,7.04A7.04,7.04,0,0,0,496.41,51.23Z",
    transform: "translate(91.477 4.316)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M495.484,71.082a6.242,6.242,0,1,0-6.242,6.242A6.242,6.242,0,0,0,495.484,71.082Z",
    transform: "translate(91.593 7.895)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M494.605,90.933a5.433,5.433,0,1,0-5.432,5.433A5.433,5.433,0,0,0,494.605,90.933Z",
    transform: "translate(91.721 11.476)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M493.626,110.793A4.623,4.623,0,1,0,489,115.416a4.623,4.623,0,0,0,4.623-4.623Z",
    transform: "translate(91.832 15.059)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M492.71,130.647a3.813,3.813,0,1,0-1.121,2.7,3.825,3.825,0,0,0,1.121-2.7Z",
    transform: "translate(91.95 18.636)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M491.781,150.5a3.015,3.015,0,1,0-3.015,3.016,3.015,3.015,0,0,0,3.015-3.016Z",
    transform: "translate(92.07 22.219)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M490.852,170.328a2.206,2.206,0,1,0-2.206,2.194,2.206,2.206,0,0,0,2.206-2.194Z",
    transform: "translate(92.189 25.795)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M489.923,190.208a1.385,1.385,0,1,0-.41.983A1.4,1.4,0,0,0,489.923,190.208Z",
    transform: "translate(92.309 29.381)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 8.671,
    cy: 8.671,
    r: 8.671,
    transform: "translate(589.506)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 7.861,
    cy: 7.861,
    r: 7.861,
    transform: "translate(590.315 24.253)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 7.052,
    cy: 7.052,
    r: 7.052,
    transform: "translate(591.125 48.494)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M510.264,71.082a6.242,6.242,0,1,0-6.242,6.242A6.242,6.242,0,0,0,510.264,71.082Z",
    transform: "translate(94.155 7.895)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M509.335,90.933a5.433,5.433,0,1,0-5.432,5.433,5.432,5.432,0,0,0,5.432-5.433Z",
    transform: "translate(94.274 11.476)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M508.366,110.793a4.623,4.623,0,1,0-4.623,4.623,4.623,4.623,0,0,0,4.623-4.623Z",
    transform: "translate(94.387 15.059)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M507.477,130.643a3.8,3.8,0,1,0-1.113,2.7,3.813,3.813,0,0,0,1.113-2.7Z",
    transform: "translate(94.514 18.64)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M506.547,150.492a3,3,0,1,0-.876,2.132,3,3,0,0,0,.876-2.132Z",
    transform: "translate(94.633 22.223)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M505.648,170.324a2.194,2.194,0,1,0-2.194,2.194,2.194,2.194,0,0,0,2.194-2.194Z",
    transform: "translate(94.758 25.798)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M504.693,190.208a1.4,1.4,0,1,0-1.385,1.385A1.4,1.4,0,0,0,504.693,190.208Z",
    transform: "translate(94.869 29.381)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 8.671,
    cy: 8.671,
    r: 8.671,
    transform: "translate(606.836)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 7.861,
    cy: 7.861,
    r: 7.861,
    transform: "translate(607.646 24.253)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 7.052,
    cy: 7.052,
    r: 7.052,
    transform: "translate(608.455 48.494)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 6.242,
    cy: 6.242,
    r: 6.242,
    transform: "translate(609.265 72.735)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M524.119,90.936a5.444,5.444,0,1,0-5.432,5.433,5.444,5.444,0,0,0,5.432-5.433Z",
    transform: "translate(96.833 11.472)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M523.189,110.8a4.635,4.635,0,1,0-4.623,4.623,4.634,4.634,0,0,0,4.623-4.623Z",
    transform: "translate(96.952 15.055)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M522.26,130.647a3.825,3.825,0,1,0-3.813,3.813A3.825,3.825,0,0,0,522.26,130.647Z",
    transform: "translate(97.072 18.636)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M521.331,150.5a3,3,0,1,0-.876,2.132A3.016,3.016,0,0,0,521.331,150.5Z",
    transform: "translate(97.191 22.219)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M520.4,170.328a2.206,2.206,0,1,0-2.194,2.194,2.206,2.206,0,0,0,2.194-2.194Z",
    transform: "translate(97.311 25.795)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M519.473,190.208a1.4,1.4,0,1,0-1.384,1.385,1.4,1.4,0,0,0,1.384-1.385Z",
    transform: "translate(97.431 29.381)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 8.671,
    cy: 8.671,
    r: 8.671,
    transform: "translate(624.178)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 7.861,
    cy: 7.861,
    r: 7.861,
    transform: "translate(624.987 24.253)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 7.052,
    cy: 7.052,
    r: 7.052,
    transform: "translate(625.797 48.494)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 6.242,
    cy: 6.242,
    r: 6.242,
    transform: "translate(626.607 72.735)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 5.433,
    cy: 5.433,
    r: 5.433,
    transform: "translate(627.416 96.988)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M537.956,110.793a4.623,4.623,0,1,0-4.623,4.623,4.623,4.623,0,0,0,4.623-4.623Z",
    transform: "translate(99.516 15.059)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M537.04,130.647a3.813,3.813,0,1,0-1.121,2.7,3.825,3.825,0,0,0,1.121-2.7Z",
    transform: "translate(99.634 18.636)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M536.111,150.5a3.015,3.015,0,1,0-3.015,3.016,3.015,3.015,0,0,0,3.015-3.016Z",
    transform: "translate(99.753 22.219)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M535.182,170.328a2.206,2.206,0,1,0-2.206,2.194,2.206,2.206,0,0,0,2.206-2.194Z",
    transform: "translate(99.873 25.795)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M534.253,190.208a1.385,1.385,0,1,0-.41.983A1.4,1.4,0,0,0,534.253,190.208Z",
    transform: "translate(99.993 29.381)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 8.671,
    cy: 8.671,
    r: 8.671,
    transform: "translate(641.52)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 7.861,
    cy: 7.861,
    r: 7.861,
    transform: "translate(642.329 24.253)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 7.052,
    cy: 7.052,
    r: 7.052,
    transform: "translate(643.139 48.494)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 6.242,
    cy: 6.242,
    r: 6.242,
    transform: "translate(643.949 72.735)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 5.433,
    cy: 5.433,
    r: 5.433,
    transform: "translate(644.758 96.988)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 4.623,
    cy: 4.623,
    r: 4.623,
    transform: "translate(645.568 121.229)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 3.813,
    cy: 3.813,
    r: 3.813,
    transform: "translate(646.377 145.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M550.887,150.492a3,3,0,1,0-.876,2.131A3,3,0,0,0,550.887,150.492Z",
    transform: "translate(102.319 22.223)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M549.948,170.324a2.194,2.194,0,1,0-2.194,2.194,2.194,2.194,0,0,0,2.194-2.194Z",
    transform: "translate(102.437 25.798)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M549.022,190.208a1.4,1.4,0,1,0-1.385,1.385A1.4,1.4,0,0,0,549.022,190.208Z",
    transform: "translate(102.553 29.381)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 8.671,
    cy: 8.671,
    r: 8.671,
    transform: "translate(658.85)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 7.861,
    cy: 7.861,
    r: 7.861,
    transform: "translate(659.659 24.253)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 7.052,
    cy: 7.052,
    r: 7.052,
    transform: "translate(660.469 48.494)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 6.242,
    cy: 6.242,
    r: 6.242,
    transform: "translate(661.279 72.735)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 5.433,
    cy: 5.433,
    r: 5.433,
    transform: "translate(662.088 96.988)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 4.623,
    cy: 4.623,
    r: 4.623,
    transform: "translate(662.898 121.229)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 3.813,
    cy: 3.813,
    r: 3.813,
    transform: "translate(663.708 145.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M565.661,150.5a3,3,0,1,0-.876,2.132,3.016,3.016,0,0,0,.876-2.132Z",
    transform: "translate(104.875 22.219)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M564.732,170.328a2.206,2.206,0,1,0-2.194,2.194,2.206,2.206,0,0,0,2.194-2.194Z",
    transform: "translate(104.995 25.795)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M563.8,190.208a1.4,1.4,0,1,0-1.385,1.385A1.4,1.4,0,0,0,563.8,190.208Z",
    transform: "translate(105.115 29.381)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 8.671,
    cy: 8.671,
    r: 8.671,
    transform: "translate(676.192)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 7.861,
    cy: 7.861,
    r: 7.861,
    transform: "translate(677.001 24.253)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 7.052,
    cy: 7.052,
    r: 7.052,
    transform: "translate(677.811 48.494)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 6.242,
    cy: 6.242,
    r: 6.242,
    transform: "translate(678.621 72.735)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 5.433,
    cy: 5.433,
    r: 5.433,
    transform: "translate(679.43 96.988)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 4.623,
    cy: 4.623,
    r: 4.623,
    transform: "translate(680.24 121.229)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 3.813,
    cy: 3.813,
    r: 3.813,
    transform: "translate(681.049 145.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M580.441,150.5a3.015,3.015,0,1,0-3.015,3.016,3.015,3.015,0,0,0,3.015-3.016Z",
    transform: "translate(107.437 22.219)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M579.512,170.322a2.206,2.206,0,1,0-2.182,2.229,2.206,2.206,0,0,0,2.182-2.229Z",
    transform: "translate(107.557 25.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M578.583,190.208a1.385,1.385,0,1,0-.41.983A1.4,1.4,0,0,0,578.583,190.208Z",
    transform: "translate(107.676 29.381)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 8.671,
    cy: 8.671,
    r: 8.671,
    transform: "translate(693.534)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 7.861,
    cy: 7.861,
    r: 7.861,
    transform: "translate(694.343 24.253)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 7.052,
    cy: 7.052,
    r: 7.052,
    transform: "translate(695.153 48.494)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 6.242,
    cy: 6.242,
    r: 6.242,
    transform: "translate(695.962 72.735)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 5.433,
    cy: 5.433,
    r: 5.433,
    transform: "translate(696.772 96.988)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 4.623,
    cy: 4.623,
    r: 4.623,
    transform: "translate(697.582 121.229)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 3.813,
    cy: 3.813,
    r: 3.813,
    transform: "translate(698.391 145.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M595.207,150.492a3,3,0,1,0-.876,2.132A3,3,0,0,0,595.207,150.492Z",
    transform: "translate(110.001 22.223)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M594.278,170.324a2.194,2.194,0,1,0-2.194,2.194A2.194,2.194,0,0,0,594.278,170.324Z",
    transform: "translate(110.12 25.798)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M593.349,190.2a1.385,1.385,0,1,0-1.385,1.385A1.385,1.385,0,0,0,593.349,190.2Z",
    transform: "translate(110.24 29.385)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 8.671,
    cy: 8.671,
    r: 8.671,
    transform: "translate(710.864)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 7.861,
    cy: 7.861,
    r: 7.861,
    transform: "translate(711.673 24.253)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 7.052,
    cy: 7.052,
    r: 7.052,
    transform: "translate(712.483 48.494)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 6.242,
    cy: 6.242,
    r: 6.242,
    transform: "translate(713.292 72.735)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 5.433,
    cy: 5.433,
    r: 5.433,
    transform: "translate(714.102 96.988)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 4.623,
    cy: 4.623,
    r: 4.623,
    transform: "translate(714.912 121.229)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 3.813,
    cy: 3.813,
    r: 3.813,
    transform: "translate(715.721 145.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M609.991,150.5a3,3,0,1,0-.876,2.132A3.016,3.016,0,0,0,609.991,150.5Z",
    transform: "translate(112.559 22.219)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M609.062,170.328a2.206,2.206,0,1,0-2.194,2.194,2.206,2.206,0,0,0,2.194-2.194Z",
    transform: "translate(112.679 25.795)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M608.132,190.208a1.4,1.4,0,1,0-1.385,1.385A1.4,1.4,0,0,0,608.132,190.208Z",
    transform: "translate(112.799 29.381)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 8.671,
    cy: 8.671,
    r: 8.671,
    transform: "translate(728.206)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 7.861,
    cy: 7.861,
    r: 7.861,
    transform: "translate(729.015 24.253)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 7.052,
    cy: 7.052,
    r: 7.052,
    transform: "translate(729.825 48.494)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 6.242,
    cy: 6.242,
    r: 6.242,
    transform: "translate(730.634 72.735)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 5.433,
    cy: 5.433,
    r: 5.433,
    transform: "translate(731.444 96.988)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 4.623,
    cy: 4.623,
    r: 4.623,
    transform: "translate(732.254 121.229)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 3.813,
    cy: 3.813,
    r: 3.813,
    transform: "translate(733.063 145.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M624.771,150.5a3.015,3.015,0,1,0-3.015,3.016,3.015,3.015,0,0,0,3.015-3.016Z",
    transform: "translate(115.121 22.219)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M623.842,170.328a2.206,2.206,0,1,0-2.206,2.194,2.206,2.206,0,0,0,2.206-2.194Z",
    transform: "translate(115.241 25.795)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M622.912,190.208a1.385,1.385,0,1,0-.41.983,1.4,1.4,0,0,0,.41-.983Z",
    transform: "translate(115.36 29.381)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 8.671,
    cy: 8.671,
    r: 8.671,
    transform: "translate(745.547)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 7.861,
    cy: 7.861,
    r: 7.861,
    transform: "translate(746.357 24.253)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 7.052,
    cy: 7.052,
    r: 7.052,
    transform: "translate(747.167 48.494)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 6.242,
    cy: 6.242,
    r: 6.242,
    transform: "translate(747.976 72.735)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 5.433,
    cy: 5.433,
    r: 5.433,
    transform: "translate(748.786 96.988)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 4.623,
    cy: 4.623,
    r: 4.623,
    transform: "translate(749.595 121.229)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 3.813,
    cy: 3.813,
    r: 3.813,
    transform: "translate(750.405 145.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M639.537,150.492a3,3,0,1,0-.876,2.132A3,3,0,0,0,639.537,150.492Z",
    transform: "translate(117.685 22.223)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M638.648,170.324a2.194,2.194,0,1,0-2.194,2.194,2.194,2.194,0,0,0,2.194-2.194Z",
    transform: "translate(117.811 25.798)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M637.693,190.208a1.4,1.4,0,1,0-1.4,1.384,1.4,1.4,0,0,0,1.4-1.384Z",
    transform: "translate(117.922 29.381)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 8.671,
    cy: 8.671,
    r: 8.671,
    transform: "translate(762.878)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 7.861,
    cy: 7.861,
    r: 7.861,
    transform: "translate(763.687 24.253)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 7.052,
    cy: 7.052,
    r: 7.052,
    transform: "translate(764.497 48.494)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 6.242,
    cy: 6.242,
    r: 6.242,
    transform: "translate(765.306 72.735)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 5.433,
    cy: 5.433,
    r: 5.433,
    transform: "translate(766.116 96.988)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 4.623,
    cy: 4.623,
    r: 4.623,
    transform: "translate(766.926 121.229)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 3.813,
    cy: 3.813,
    r: 3.813,
    transform: "translate(767.735 145.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M654.321,150.5a3,3,0,1,0-.876,2.132A3.015,3.015,0,0,0,654.321,150.5Z",
    transform: "translate(120.243 22.219)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M653.392,170.328a2.206,2.206,0,1,0-2.194,2.194,2.206,2.206,0,0,0,2.194-2.194Z",
    transform: "translate(120.363 25.795)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M652.463,190.208a1.4,1.4,0,1,0-1.385,1.385,1.4,1.4,0,0,0,1.385-1.385Z",
    transform: "translate(120.482 29.381)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 8.671,
    cy: 8.671,
    r: 8.671,
    transform: "translate(780.219)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 7.861,
    cy: 7.861,
    r: 7.861,
    transform: "translate(781.029 24.253)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 7.052,
    cy: 7.052,
    r: 7.052,
    transform: "translate(781.839 48.494)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 6.242,
    cy: 6.242,
    r: 6.242,
    transform: "translate(782.648 72.735)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 5.433,
    cy: 5.433,
    r: 5.433,
    transform: "translate(783.458 96.988)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 4.623,
    cy: 4.623,
    r: 4.623,
    transform: "translate(784.267 121.229)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 3.813,
    cy: 3.813,
    r: 3.813,
    transform: "translate(785.077 145.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M669.1,150.5a3.015,3.015,0,1,0-3.015,3.016A3.015,3.015,0,0,0,669.1,150.5Z",
    transform: "translate(122.805 22.219)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M668.172,170.328a2.206,2.206,0,1,0-2.206,2.194,2.206,2.206,0,0,0,2.206-2.194Z",
    transform: "translate(122.924 25.795)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M667.242,190.208a1.385,1.385,0,1,0-.41.983,1.4,1.4,0,0,0,.41-.983Z",
    transform: "translate(123.044 29.381)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 8.671,
    cy: 8.671,
    r: 8.671,
    transform: "translate(797.561)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 7.861,
    cy: 7.861,
    r: 7.861,
    transform: "translate(798.371 24.253)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 7.052,
    cy: 7.052,
    r: 7.052,
    transform: "translate(799.18 48.494)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 6.242,
    cy: 6.242,
    r: 6.242,
    transform: "translate(799.99 72.735)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 5.433,
    cy: 5.433,
    r: 5.433,
    transform: "translate(800.8 96.988)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 4.623,
    cy: 4.623,
    r: 4.623,
    transform: "translate(801.609 121.229)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 3.813,
    cy: 3.813,
    r: 3.813,
    transform: "translate(802.419 145.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M683.887,150.492a3,3,0,1,0-.876,2.132A3,3,0,0,0,683.887,150.492Z",
    transform: "translate(125.372 22.223)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M682.938,170.324a2.194,2.194,0,1,0-2.194,2.194,2.194,2.194,0,0,0,2.194-2.194Z",
    transform: "translate(125.488 25.798)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M682.022,190.208a1.385,1.385,0,1,0-.41.983A1.4,1.4,0,0,0,682.022,190.208Z",
    transform: "translate(125.606 29.381)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 8.671,
    cy: 8.671,
    r: 8.671,
    transform: "translate(814.891)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 7.861,
    cy: 7.861,
    r: 7.861,
    transform: "translate(815.701 24.253)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 7.052,
    cy: 7.052,
    r: 7.052,
    transform: "translate(816.511 48.494)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 6.242,
    cy: 6.242,
    r: 6.242,
    transform: "translate(817.32 72.735)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 5.433,
    cy: 5.433,
    r: 5.433,
    transform: "translate(818.13 96.988)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 4.623,
    cy: 4.623,
    r: 4.623,
    transform: "translate(818.939 121.229)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 3.813,
    cy: 3.813,
    r: 3.813,
    transform: "translate(819.749 145.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M698.651,150.5a3,3,0,1,0-.876,2.132A3.015,3.015,0,0,0,698.651,150.5Z",
    transform: "translate(127.927 22.219)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M697.722,170.328a2.206,2.206,0,1,0-2.194,2.194,2.206,2.206,0,0,0,2.194-2.194Z",
    transform: "translate(128.046 25.795)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M696.792,190.208a1.4,1.4,0,1,0-1.385,1.385A1.4,1.4,0,0,0,696.792,190.208Z",
    transform: "translate(128.166 29.381)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 8.671,
    cy: 8.671,
    r: 8.671,
    transform: "translate(832.233)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 7.861,
    cy: 7.861,
    r: 7.861,
    transform: "translate(833.043 24.253)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 7.052,
    cy: 7.052,
    r: 7.052,
    transform: "translate(833.852 48.494)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 6.242,
    cy: 6.242,
    r: 6.242,
    transform: "translate(834.662 72.735)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 5.433,
    cy: 5.433,
    r: 5.433,
    transform: "translate(835.472 96.988)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 4.623,
    cy: 4.623,
    r: 4.623,
    transform: "translate(836.281 121.229)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 3.813,
    cy: 3.813,
    r: 3.813,
    transform: "translate(837.091 145.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M713.431,150.5a3.015,3.015,0,1,0-3.015,3.016,3.015,3.015,0,0,0,3.015-3.016Z",
    transform: "translate(130.489 22.219)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M712.5,170.322a2.206,2.206,0,1,0-2.171,2.229A2.206,2.206,0,0,0,712.5,170.322Z",
    transform: "translate(130.608 25.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M711.572,190.208a1.385,1.385,0,1,0-.41.983A1.4,1.4,0,0,0,711.572,190.208Z",
    transform: "translate(130.728 29.381)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 8.671,
    cy: 8.671,
    r: 8.671,
    transform: "translate(849.575)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 7.861,
    cy: 7.861,
    r: 7.861,
    transform: "translate(850.385 24.253)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 7.052,
    cy: 7.052,
    r: 7.052,
    transform: "translate(851.194 48.494)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 6.242,
    cy: 6.242,
    r: 6.242,
    transform: "translate(852.004 72.735)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 5.433,
    cy: 5.433,
    r: 5.433,
    transform: "translate(852.814 96.988)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 4.623,
    cy: 4.623,
    r: 4.623,
    transform: "translate(853.623 121.229)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 3.813,
    cy: 3.813,
    r: 3.813,
    transform: "translate(854.433 145.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M728.2,150.492a3,3,0,1,0-.876,2.132A3,3,0,0,0,728.2,150.492Z",
    transform: "translate(133.052 22.223)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M727.282,170.328a2.206,2.206,0,1,0-2.206,2.194,2.206,2.206,0,0,0,2.206-2.194Z",
    transform: "translate(133.17 25.795)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M726.352,190.208a1.384,1.384,0,1,0-.41.983,1.4,1.4,0,0,0,.41-.983Z",
    transform: "translate(133.29 29.381)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 8.671,
    cy: 8.671,
    r: 8.671,
    transform: "translate(866.905)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 7.861,
    cy: 7.861,
    r: 7.861,
    transform: "translate(867.715 24.253)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 7.052,
    cy: 7.052,
    r: 7.052,
    transform: "translate(868.524 48.494)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 6.242,
    cy: 6.242,
    r: 6.242,
    transform: "translate(869.334 72.735)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 5.433,
    cy: 5.433,
    r: 5.433,
    transform: "translate(870.144 96.988)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 4.623,
    cy: 4.623,
    r: 4.623,
    transform: "translate(870.953 121.229)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M743.907,130.643a3.813,3.813,0,1,0-3.813,3.813,3.813,3.813,0,0,0,3.813-3.813Z",
    transform: "translate(135.495 18.64)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M742.981,150.5a3,3,0,1,0-.876,2.132,3.015,3.015,0,0,0,.876-2.132Z",
    transform: "translate(135.611 22.219)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M742.052,170.328a2.206,2.206,0,1,0-2.194,2.194,2.206,2.206,0,0,0,2.194-2.194Z",
    transform: "translate(135.73 25.795)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M741.122,190.208a1.4,1.4,0,1,0-1.385,1.385A1.4,1.4,0,0,0,741.122,190.208Z",
    transform: "translate(135.85 29.381)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 8.671,
    cy: 8.671,
    r: 8.671,
    transform: "translate(884.247)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 7.861,
    cy: 7.861,
    r: 7.861,
    transform: "translate(885.057 24.253)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 7.052,
    cy: 7.052,
    r: 7.052,
    transform: "translate(885.866 48.494)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 6.242,
    cy: 6.242,
    r: 6.242,
    transform: "translate(886.676 72.735)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 5.433,
    cy: 5.433,
    r: 5.433,
    transform: "translate(887.486 96.988)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M759.619,110.8a4.635,4.635,0,1,0-4.693,4.623,4.694,4.694,0,0,0,4.693-4.623Z",
    transform: "translate(137.933 15.055)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M758.69,130.647a3.813,3.813,0,1,0-1.121,2.7,3.825,3.825,0,0,0,1.121-2.7Z",
    transform: "translate(138.053 18.636)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M757.761,150.5a3.015,3.015,0,1,0-3.016,3.016,3.015,3.015,0,0,0,3.016-3.016Z",
    transform: "translate(138.173 22.219)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M756.832,170.328a2.206,2.206,0,1,0-2.206,2.194,2.206,2.206,0,0,0,2.206-2.194Z",
    transform: "translate(138.292 25.795)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M755.9,190.208a1.384,1.384,0,1,0-.41.983,1.4,1.4,0,0,0,.41-.983Z",
    transform: "translate(138.412 29.381)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M-51.272,169.414a2.464,2.464,0,0,1-2.464,2.464,2.464,2.464,0,0,1-2.464-2.464,2.464,2.464,0,0,1,2.464-2.464,2.464,2.464,0,0,1,2.464,2.464Z",
    transform: "translate(-9.741 28.938)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M-33.412,169.414a2.464,2.464,0,0,1-2.464,2.464,2.464,2.464,0,0,1-2.464-2.464,2.464,2.464,0,0,1,2.464-2.464,2.464,2.464,0,0,1,2.464,2.464Z",
    transform: "translate(-6.646 28.938)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M-15.542,169.414a2.464,2.464,0,0,1-2.464,2.464,2.464,2.464,0,0,1-2.464-2.464,2.464,2.464,0,0,1,2.464-2.464,2.464,2.464,0,0,1,2.464,2.464Z",
    transform: "translate(-3.548 28.938)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "h",
    cx: 2.464,
    cy: 2.464,
    r: 2.464,
    transform: "translate(-3.051 195.9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M20.2,169.414a2.464,2.464,0,1,1-2.464-2.464,2.464,2.464,0,0,1,2.464,2.464Z",
    transform: "translate(2.647 28.938)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M38.068,169.414A2.464,2.464,0,1,1,35.6,166.95a2.464,2.464,0,0,1,2.464,2.464Z",
    transform: "translate(5.744 28.938)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M55.938,169.414a2.464,2.464,0,1,1-2.452-2.464A2.464,2.464,0,0,1,55.938,169.414Z",
    transform: "translate(8.842 28.938)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "h",
    cx: 2.464,
    cy: 2.464,
    r: 2.464,
    transform: "translate(80.819 195.9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M91.728,169.414a2.464,2.464,0,1,1-2.464-2.464A2.464,2.464,0,0,1,91.728,169.414Z",
    transform: "translate(15.045 28.938)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M-51.272,184.272a2.464,2.464,0,0,1-2.464,2.464,2.464,2.464,0,0,1-2.464-2.464,2.452,2.452,0,0,1,.722-1.738,2.452,2.452,0,0,1,1.742-.714,2.452,2.452,0,0,1,1.742.714A2.452,2.452,0,0,1-51.272,184.272Z",
    transform: "translate(-9.741 31.515)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M-33.412,184.272a2.464,2.464,0,0,1-2.464,2.464,2.464,2.464,0,0,1-2.464-2.464,2.452,2.452,0,0,1,.722-1.738,2.452,2.452,0,0,1,1.742-.714,2.452,2.452,0,0,1,1.742.714A2.452,2.452,0,0,1-33.412,184.272Z",
    transform: "translate(-6.646 31.515)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M-15.542,184.272a2.464,2.464,0,0,1-2.464,2.464,2.464,2.464,0,0,1-2.464-2.464,2.452,2.452,0,0,1,.722-1.738,2.452,2.452,0,0,1,1.742-.714,2.452,2.452,0,0,1,1.742.714,2.452,2.452,0,0,1,.722,1.738Z",
    transform: "translate(-3.548 31.515)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M2.328,184.274a2.464,2.464,0,0,1-2.464,2.452A2.464,2.464,0,0,1-2.6,184.262a2.452,2.452,0,0,1,.722-1.738,2.452,2.452,0,0,1,1.742-.714,2.452,2.452,0,0,1,1.746.718,2.452,2.452,0,0,1,.718,1.746Z",
    transform: "translate(-0.451 31.514)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M20.2,184.272a2.464,2.464,0,1,1-2.464-2.452,2.464,2.464,0,0,1,2.464,2.452Z",
    transform: "translate(2.647 31.515)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M38.068,184.272A2.464,2.464,0,1,1,35.6,181.82a2.464,2.464,0,0,1,2.464,2.452Z",
    transform: "translate(5.744 31.515)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M55.938,184.272a2.464,2.464,0,1,1-2.452-2.452A2.464,2.464,0,0,1,55.938,184.272Z",
    transform: "translate(8.842 31.515)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M73.818,184.272a2.464,2.464,0,1,1-2.464-2.452,2.464,2.464,0,0,1,2.464,2.452Z",
    transform: "translate(11.941 31.515)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M91.728,184.272a2.464,2.464,0,1,1-2.464-2.452,2.464,2.464,0,0,1,2.464,2.452Z",
    transform: "translate(15.045 31.515)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M-51.272,199.132a2.464,2.464,0,0,1-2.464,2.464,2.464,2.464,0,0,1-2.464-2.464,2.464,2.464,0,0,1,2.464-2.452,2.464,2.464,0,0,1,2.464,2.452Z",
    transform: "translate(-9.741 34.091)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M-33.412,199.132a2.464,2.464,0,0,1-2.464,2.464,2.464,2.464,0,0,1-2.464-2.464,2.464,2.464,0,0,1,2.464-2.452,2.464,2.464,0,0,1,2.464,2.452Z",
    transform: "translate(-6.646 34.091)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M-15.542,199.132a2.464,2.464,0,0,1-2.464,2.464,2.464,2.464,0,0,1-2.464-2.464,2.464,2.464,0,0,1,2.464-2.452,2.464,2.464,0,0,1,2.464,2.452Z",
    transform: "translate(-3.548 34.091)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M2.328,199.132A2.464,2.464,0,0,1-.136,201.6,2.464,2.464,0,0,1-2.6,199.132,2.464,2.464,0,0,1-.136,196.68a2.464,2.464,0,0,1,2.464,2.452Z",
    transform: "translate(-0.451 34.091)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M20.2,199.132a2.464,2.464,0,1,1-2.464-2.452,2.464,2.464,0,0,1,2.464,2.452Z",
    transform: "translate(2.647 34.091)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M38.068,199.132A2.464,2.464,0,1,1,35.6,196.68a2.464,2.464,0,0,1,2.464,2.452Z",
    transform: "translate(5.744 34.091)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M55.938,199.132a2.464,2.464,0,1,1-2.452-2.452A2.464,2.464,0,0,1,55.938,199.132Z",
    transform: "translate(8.842 34.091)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M73.818,199.132a2.464,2.464,0,1,1-2.464-2.452,2.464,2.464,0,0,1,2.464,2.452Z",
    transform: "translate(11.941 34.091)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M91.728,199.132a2.464,2.464,0,1,1-2.464-2.452,2.464,2.464,0,0,1,2.464,2.452Z",
    transform: "translate(15.045 34.091)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M-51.272,214a2.464,2.464,0,0,1-2.464,2.452A2.464,2.464,0,0,1-56.2,214a2.464,2.464,0,0,1,2.464-2.464A2.464,2.464,0,0,1-51.272,214Z",
    transform: "translate(-9.741 36.667)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M-33.412,214a2.464,2.464,0,0,1-2.464,2.452A2.464,2.464,0,0,1-38.34,214a2.464,2.464,0,0,1,2.464-2.464A2.464,2.464,0,0,1-33.412,214Z",
    transform: "translate(-6.646 36.667)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M-15.542,214a2.464,2.464,0,0,1-2.464,2.452A2.464,2.464,0,0,1-20.47,214a2.464,2.464,0,0,1,2.464-2.464A2.464,2.464,0,0,1-15.542,214Z",
    transform: "translate(-3.548 36.667)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M2.328,214a2.464,2.464,0,0,1-2.464,2.452A2.464,2.464,0,0,1-2.6,214,2.464,2.464,0,0,1-.136,211.54,2.464,2.464,0,0,1,2.328,214Z",
    transform: "translate(-0.451 36.667)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M20.2,214a2.464,2.464,0,1,1-2.464-2.464A2.464,2.464,0,0,1,20.2,214Z",
    transform: "translate(2.647 36.667)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M38.068,214A2.464,2.464,0,1,1,35.6,211.54,2.464,2.464,0,0,1,38.068,214Z",
    transform: "translate(5.744 36.667)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M55.938,214a2.464,2.464,0,1,1-2.452-2.464A2.464,2.464,0,0,1,55.938,214Z",
    transform: "translate(8.842 36.667)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M73.818,214a2.464,2.464,0,1,1-2.464-2.464A2.464,2.464,0,0,1,73.818,214Z",
    transform: "translate(11.941 36.667)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M91.728,214a2.464,2.464,0,1,1-2.464-2.464A2.464,2.464,0,0,1,91.728,214Z",
    transform: "translate(15.045 36.667)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M-51.272,228.864a2.464,2.464,0,0,1-2.464,2.452,2.464,2.464,0,0,1-2.464-2.452,2.464,2.464,0,0,1,2.464-2.464A2.464,2.464,0,0,1-51.272,228.864Z",
    transform: "translate(-9.741 39.243)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M-33.412,228.864a2.464,2.464,0,0,1-2.464,2.452,2.464,2.464,0,0,1-2.464-2.452,2.464,2.464,0,0,1,2.464-2.464A2.464,2.464,0,0,1-33.412,228.864Z",
    transform: "translate(-6.646 39.243)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M-15.542,228.864a2.464,2.464,0,0,1-2.464,2.452,2.464,2.464,0,0,1-2.464-2.452,2.464,2.464,0,0,1,2.464-2.464A2.464,2.464,0,0,1-15.542,228.864Z",
    transform: "translate(-3.548 39.243)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M2.328,228.864a2.464,2.464,0,0,1-2.464,2.452A2.464,2.464,0,0,1-2.6,228.864,2.464,2.464,0,0,1-.136,226.4a2.464,2.464,0,0,1,2.464,2.464Z",
    transform: "translate(-0.451 39.243)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M20.2,228.864a2.464,2.464,0,1,1-2.464-2.464,2.464,2.464,0,0,1,2.464,2.464Z",
    transform: "translate(2.647 39.243)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M38.068,228.864A2.464,2.464,0,1,1,35.6,226.4a2.464,2.464,0,0,1,2.464,2.464Z",
    transform: "translate(5.744 39.243)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M55.938,228.864a2.464,2.464,0,1,1-2.452-2.464A2.464,2.464,0,0,1,55.938,228.864Z",
    transform: "translate(8.842 39.243)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M73.818,228.864a2.464,2.464,0,1,1-2.464-2.464,2.464,2.464,0,0,1,2.464,2.464Z",
    transform: "translate(11.941 39.243)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M91.728,228.864a2.464,2.464,0,1,1-2.464-2.464,2.464,2.464,0,0,1,2.464,2.464Z",
    transform: "translate(15.045 39.243)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M-51.272,243.724a2.452,2.452,0,0,1-.722,1.738,2.452,2.452,0,0,1-1.742.714,2.452,2.452,0,0,1-1.742-.714,2.452,2.452,0,0,1-.722-1.738,2.464,2.464,0,0,1,2.464-2.464A2.464,2.464,0,0,1-51.272,243.724Z",
    transform: "translate(-9.741 41.818)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M-33.412,243.724a2.452,2.452,0,0,1-.722,1.738,2.452,2.452,0,0,1-1.742.714,2.452,2.452,0,0,1-1.742-.714,2.452,2.452,0,0,1-.722-1.738,2.464,2.464,0,0,1,2.464-2.464A2.464,2.464,0,0,1-33.412,243.724Z",
    transform: "translate(-6.646 41.818)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M-15.542,243.724a2.452,2.452,0,0,1-.722,1.738,2.452,2.452,0,0,1-1.742.714,2.452,2.452,0,0,1-1.742-.714,2.452,2.452,0,0,1-.722-1.738,2.464,2.464,0,0,1,2.464-2.464A2.464,2.464,0,0,1-15.542,243.724Z",
    transform: "translate(-3.548 41.818)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "h",
    cx: 2.464,
    cy: 2.464,
    r: 2.464,
    transform: "translate(-3.051 283.078)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M20.2,243.724a2.452,2.452,0,1,1-.718-1.746,2.464,2.464,0,0,1,.718,1.746Z",
    transform: "translate(2.647 41.818)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M38.068,243.724a2.452,2.452,0,1,1-.718-1.746A2.464,2.464,0,0,1,38.068,243.724Z",
    transform: "translate(5.744 41.818)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M55.938,243.724a2.452,2.452,0,1,1-.714-1.742,2.464,2.464,0,0,1,.714,1.742Z",
    transform: "translate(8.842 41.818)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "h",
    cx: 2.464,
    cy: 2.464,
    r: 2.464,
    transform: "translate(80.819 283.078)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M91.728,243.724a2.452,2.452,0,1,1-.718-1.746A2.464,2.464,0,0,1,91.728,243.724Z",
    transform: "translate(15.045 41.818)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M-51.272,258.584a2.464,2.464,0,0,1-2.464,2.464,2.464,2.464,0,0,1-2.464-2.464,2.464,2.464,0,0,1,2.464-2.464A2.464,2.464,0,0,1-51.272,258.584Z",
    transform: "translate(-9.741 44.394)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M-33.412,258.584a2.464,2.464,0,0,1-2.464,2.464,2.464,2.464,0,0,1-2.464-2.464,2.464,2.464,0,0,1,2.464-2.464A2.464,2.464,0,0,1-33.412,258.584Z",
    transform: "translate(-6.646 44.394)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M-15.542,258.584a2.464,2.464,0,0,1-2.464,2.464,2.464,2.464,0,0,1-2.464-2.464,2.464,2.464,0,0,1,2.464-2.464A2.464,2.464,0,0,1-15.542,258.584Z",
    transform: "translate(-3.548 44.394)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M2.328,258.584a2.464,2.464,0,0,1-2.464,2.464A2.464,2.464,0,0,1-2.6,258.584,2.464,2.464,0,0,1-.136,256.12,2.464,2.464,0,0,1,2.328,258.584Z",
    transform: "translate(-0.451 44.394)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M20.2,258.584a2.464,2.464,0,1,1-2.464-2.464,2.464,2.464,0,0,1,2.464,2.464Z",
    transform: "translate(2.647 44.394)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M38.068,258.584A2.464,2.464,0,1,1,35.6,256.12,2.464,2.464,0,0,1,38.068,258.584Z",
    transform: "translate(5.744 44.394)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M55.938,258.584a2.464,2.464,0,1,1-2.452-2.464,2.464,2.464,0,0,1,2.452,2.464Z",
    transform: "translate(8.842 44.394)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M73.818,258.584a2.464,2.464,0,1,1-2.464-2.464A2.464,2.464,0,0,1,73.818,258.584Z",
    transform: "translate(11.941 44.394)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M91.728,258.584a2.464,2.464,0,1,1-2.464-2.464A2.464,2.464,0,0,1,91.728,258.584Z",
    transform: "translate(15.045 44.394)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M-51.272,273.444a2.464,2.464,0,0,1-2.464,2.464,2.464,2.464,0,0,1-2.464-2.464,2.464,2.464,0,0,1,2.464-2.464A2.464,2.464,0,0,1-51.272,273.444Z",
    transform: "translate(-9.741 46.97)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M-33.412,273.444a2.464,2.464,0,0,1-2.464,2.464,2.464,2.464,0,0,1-2.464-2.464,2.464,2.464,0,0,1,2.464-2.464A2.464,2.464,0,0,1-33.412,273.444Z",
    transform: "translate(-6.646 46.97)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M-15.542,273.444a2.464,2.464,0,0,1-2.464,2.464,2.464,2.464,0,0,1-2.464-2.464,2.464,2.464,0,0,1,2.464-2.464A2.464,2.464,0,0,1-15.542,273.444Z",
    transform: "translate(-3.548 46.97)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M2.328,273.44A2.464,2.464,0,0,1-.136,275.9,2.464,2.464,0,0,1-2.6,273.44,2.464,2.464,0,0,1-.136,271a2.464,2.464,0,0,1,2.464,2.441Z",
    transform: "translate(-0.451 46.973)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M20.2,273.444a2.464,2.464,0,1,1-2.464-2.464,2.464,2.464,0,0,1,2.464,2.464Z",
    transform: "translate(2.647 46.97)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M38.068,273.444A2.464,2.464,0,1,1,35.6,270.98,2.464,2.464,0,0,1,38.068,273.444Z",
    transform: "translate(5.744 46.97)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M55.938,273.444a2.464,2.464,0,1,1-2.452-2.464A2.464,2.464,0,0,1,55.938,273.444Z",
    transform: "translate(8.842 46.97)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M73.818,273.44A2.464,2.464,0,1,1,71.366,271a2.464,2.464,0,0,1,2.452,2.44Z",
    transform: "translate(11.941 46.973)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M91.728,273.444a2.464,2.464,0,1,1-2.464-2.464A2.464,2.464,0,0,1,91.728,273.444Z",
    transform: "translate(15.045 46.97)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M495.947,170.3a1.478,1.478,0,1,1-1.478-1.478A1.478,1.478,0,0,1,495.947,170.3Z",
    transform: "translate(85.451 29.262)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M506.647,170.3a1.478,1.478,0,1,1-1.478-1.478A1.478,1.478,0,0,1,506.647,170.3Z",
    transform: "translate(87.306 29.262)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M517.347,170.3a1.478,1.478,0,1,1-1.478-1.478A1.478,1.478,0,0,1,517.347,170.3Z",
    transform: "translate(89.161 29.262)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M528.047,170.3a1.478,1.478,0,1,1-1.478-1.478A1.478,1.478,0,0,1,528.047,170.3Z",
    transform: "translate(91.015 29.262)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M538.737,170.3a1.478,1.478,0,1,1-1.467-1.478,1.478,1.478,0,0,1,1.467,1.478Z",
    transform: "translate(92.868 29.262)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M549.437,170.3a1.478,1.478,0,1,1-1.467-1.478,1.478,1.478,0,0,1,1.467,1.478Z",
    transform: "translate(94.723 29.262)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "h",
    cx: 1.478,
    cy: 1.478,
    r: 1.478,
    transform: "translate(578.441 208.525)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "h",
    cx: 1.478,
    cy: 1.478,
    r: 1.478,
    transform: "translate(590.996 208.525)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "h",
    cx: 1.478,
    cy: 1.478,
    r: 1.478,
    transform: "translate(603.551 208.525)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M528.047,179.218a1.478,1.478,0,1,1-1.478-1.478,1.478,1.478,0,0,1,1.478,1.478Z",
    transform: "translate(91.015 30.808)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M538.737,179.218a1.467,1.467,0,1,1-.425-1.045A1.478,1.478,0,0,1,538.737,179.218Z",
    transform: "translate(92.868 30.808)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M549.437,179.218a1.467,1.467,0,1,1-.425-1.045A1.478,1.478,0,0,1,549.437,179.218Z",
    transform: "translate(94.723 30.808)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "h",
    cx: 1.478,
    cy: 1.478,
    r: 1.478,
    transform: "translate(578.441 218.967)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "h",
    cx: 1.478,
    cy: 1.478,
    r: 1.478,
    transform: "translate(590.996 218.967)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "h",
    cx: 1.478,
    cy: 1.478,
    r: 1.478,
    transform: "translate(603.551 218.967)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M528.047,188.087a1.478,1.478,0,1,1-1.478-1.467,1.478,1.478,0,0,1,1.478,1.467Z",
    transform: "translate(91.015 32.347)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M538.737,188.087a1.478,1.478,0,1,1-1.467-1.467,1.478,1.478,0,0,1,1.467,1.467Z",
    transform: "translate(92.868 32.347)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M549.437,188.087a1.478,1.478,0,1,1-1.467-1.467,1.478,1.478,0,0,1,1.467,1.467Z",
    transform: "translate(94.723 32.347)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M704.158,196.67a1.478,1.478,0,1,1-1.478,1.467A1.478,1.478,0,0,1,704.158,196.67Z",
    transform: "translate(121.798 34.089)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M704.158,186a1.478,1.478,0,1,1-1.478,1.478A1.478,1.478,0,0,1,704.158,186Z",
    transform: "translate(121.798 32.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M704.158,175.27a1.478,1.478,0,1,1-1.478,1.478A1.478,1.478,0,0,1,704.158,175.27Z",
    transform: "translate(121.798 30.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M704.158,164.57a1.478,1.478,0,1,1-1.478,1.478A1.478,1.478,0,0,1,704.158,164.57Z",
    transform: "translate(121.798 28.525)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M704.158,153.87a1.478,1.478,0,1,1-1.478,1.478,1.478,1.478,0,0,1,1.478-1.478Z",
    transform: "translate(121.798 26.671)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M704.158,143.17a1.478,1.478,0,1,1-1.478,1.478A1.478,1.478,0,0,1,704.158,143.17Z",
    transform: "translate(121.798 24.816)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "h",
    cx: 1.478,
    cy: 1.478,
    r: 1.478,
    transform: "translate(834.909 230.759)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "h",
    cx: 1.478,
    cy: 1.478,
    r: 1.478,
    transform: "translate(834.909 218.205)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "h",
    cx: 1.478,
    cy: 1.478,
    r: 1.478,
    transform: "translate(834.909 205.65)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M713.058,164.57a1.467,1.467,0,1,1-1.049.43,1.478,1.478,0,0,1,1.049-.43Z",
    transform: "translate(123.34 28.525)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M713.058,153.87a1.467,1.467,0,1,1-1.049.429,1.478,1.478,0,0,1,1.049-.429Z",
    transform: "translate(123.34 26.671)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "h",
    cx: 1.478,
    cy: 1.478,
    r: 1.478,
    transform: "translate(834.909 167.986)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "h",
    cx: 1.478,
    cy: 1.478,
    r: 1.478,
    transform: "translate(845.351 230.759)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "h",
    cx: 1.478,
    cy: 1.478,
    r: 1.478,
    transform: "translate(845.351 218.205)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "h",
    cx: 1.478,
    cy: 1.478,
    r: 1.478,
    transform: "translate(845.351 205.65)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M721.947,164.57a1.467,1.467,0,1,1-1.041.434,1.478,1.478,0,0,1,1.041-.434Z",
    transform: "translate(124.883 28.525)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M721.947,153.87a1.467,1.467,0,1,1-1.041.434,1.478,1.478,0,0,1,1.041-.434Z",
    transform: "translate(124.883 26.671)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "h",
    cx: 1.478,
    cy: 1.478,
    r: 1.478,
    transform: "translate(845.351 167.986)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M678.718,196.67a1.478,1.478,0,1,1-1.478,1.467A1.478,1.478,0,0,1,678.718,196.67Z",
    transform: "translate(117.388 34.089)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M678.718,186a1.478,1.478,0,1,1-1.478,1.478A1.478,1.478,0,0,1,678.718,186Z",
    transform: "translate(117.388 32.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M678.718,175.27a1.478,1.478,0,1,1-1.478,1.478A1.478,1.478,0,0,1,678.718,175.27Z",
    transform: "translate(117.388 30.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M678.718,164.57a1.478,1.478,0,1,1-1.478,1.478A1.478,1.478,0,0,1,678.718,164.57Z",
    transform: "translate(117.388 28.525)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M678.718,153.87a1.478,1.478,0,1,1-1.478,1.478,1.478,1.478,0,0,1,1.478-1.478Z",
    transform: "translate(117.388 26.671)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M678.718,143.17a1.478,1.478,0,1,1-1.478,1.478A1.478,1.478,0,0,1,678.718,143.17Z",
    transform: "translate(117.388 24.816)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "h",
    cx: 1.478,
    cy: 1.478,
    r: 1.478,
    transform: "translate(805.059 230.759)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "h",
    cx: 1.478,
    cy: 1.478,
    r: 1.478,
    transform: "translate(805.059 218.205)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "h",
    cx: 1.478,
    cy: 1.478,
    r: 1.478,
    transform: "translate(805.059 205.65)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M687.618,164.57a1.467,1.467,0,1,1-1.049.43,1.478,1.478,0,0,1,1.049-.43Z",
    transform: "translate(118.931 28.525)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M687.618,153.87a1.467,1.467,0,1,1-1.049.43,1.478,1.478,0,0,1,1.049-.43Z",
    transform: "translate(118.931 26.671)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "h",
    cx: 1.478,
    cy: 1.478,
    r: 1.478,
    transform: "translate(805.059 167.986)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "h",
    cx: 1.478,
    cy: 1.478,
    r: 1.478,
    transform: "translate(815.502 230.759)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "h",
    cx: 1.478,
    cy: 1.478,
    r: 1.478,
    transform: "translate(815.502 218.205)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "h",
    cx: 1.478,
    cy: 1.478,
    r: 1.478,
    transform: "translate(815.502 205.65)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M696.507,164.57a1.467,1.467,0,1,1-1.041.434A1.478,1.478,0,0,1,696.507,164.57Z",
    transform: "translate(120.473 28.525)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M696.507,153.87a1.467,1.467,0,1,1-1.041.434A1.478,1.478,0,0,1,696.507,153.87Z",
    transform: "translate(120.473 26.671)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "h",
    cx: 1.478,
    cy: 1.478,
    r: 1.478,
    transform: "translate(815.502 167.986)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "i",
    transform: "translate(248.465 -71.714)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M297.261-61.12a85.489,85.489,0,1,0,85.477,85.485A85.492,85.492,0,0,0,297.261-61.12Zm0,165.5a79.869,79.869,0,1,0-.008,0Z",
    transform: "translate(-211.76 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M294.531-45.37a67.009,67.009,0,1,0,67,67.005,67.012,67.012,0,0,0-67-67.005Zm0,123.763a56.806,56.806,0,1,1,.008,0Z",
    transform: "translate(-209.03 63.85)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M290.189-20.32a37.609,37.609,0,1,1-.008,0Zm0,57.8A20.193,20.193,0,1,1,310.382,17.3a20.193,20.193,0,0,1-20.193,20.181Z",
    transform: "translate(-204.688 68.192)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M669.612-30.15a60.732,60.732,0,1,0,60.732,60.732A60.732,60.732,0,0,0,669.612-30.15Zm0,109.93a49.2,49.2,0,1,1,49.2-49.2,49.2,49.2,0,0,1-49.2,49.2Z",
    transform: "translate(105.539 -5.226)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "e",
    transform: "translate(713.898 274.553)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M698.693,263.75c-9.011,2.957-16.943-5.691-25.543-7.732a20.381,20.381,0,0,0-10.713.34c-4.083,1.173-7.415,4.283-11.252,6.371-7.943,4.33-15.981,1.877-22.927-4.482-2.687-2.464-5.468-4.94-8.741-5.233-3.9-.329-7.533,2.253-10.642,5.3-1.056,1.033,0,3.52,1.009,2.464,3.931-3.849,8.436-6.524,13.106-3.6,3.309,2.065,6.054,5.573,9.387,7.627a19.043,19.043,0,0,0,20.146.211c3.813-2.265,7.228-5.139,11.358-6.172a20.146,20.146,0,0,1,13.27,1.5c7.286,3.262,14.256,8.73,22.106,6.148C700.489,266.073,699.961,263.328,698.693,263.75Z",
    transform: "translate(-608.436 -230.702)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M698.693,254.249c-9.011,2.968-16.943-5.679-25.543-7.732a20.381,20.381,0,0,0-10.713.34c-4.083,1.173-7.415,4.283-11.252,6.371-7.943,4.33-15.981,1.877-22.927-4.482-2.687-2.464-5.468-4.94-8.741-5.221-3.9-.34-7.533,2.241-10.642,5.292-1.056,1.033,0,3.52,1.009,2.464,3.931-3.849,8.436-6.524,13.106-3.6,3.309,2.065,6.054,5.573,9.387,7.627a19.043,19.043,0,0,0,20.146.211c3.813-2.265,7.228-5.139,11.358-6.172a20.146,20.146,0,0,1,13.27,1.5c7.286,3.262,14.256,8.73,22.106,6.148C700.489,256.572,699.961,253.826,698.693,254.249Z",
    transform: "translate(-608.436 -232.348)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M698.693,244.749c-9.011,2.969-16.943-5.679-25.543-7.732a20.381,20.381,0,0,0-10.713.34c-4.083,1.173-7.415,4.283-11.252,6.371-7.943,4.341-15.981,1.877-22.927-4.482-2.687-2.464-5.468-4.94-8.741-5.221-3.9-.34-7.533,2.241-10.642,5.292-1.056,1.033,0,3.52,1.009,2.464,3.931-3.849,8.436-6.524,13.106-3.6,3.309,2.065,6.054,5.573,9.387,7.627a19.043,19.043,0,0,0,20.146.211c3.813-2.265,7.228-5.139,11.358-6.172a20.216,20.216,0,0,1,13.271,1.5c7.286,3.262,14.256,8.73,22.106,6.148C700.489,247.084,699.961,244.338,698.693,244.749Z",
    transform: "translate(-608.436 -233.994)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M228.555,346.7v15.429H187.43V321h15.418v25.7Z",
    transform: "translate(-47.756 -16.074)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M530.355,182.208v15.429H489.23V156.5h15.429v25.708Z",
    transform: "translate(4.555 -44.588)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M554.1,158.468V173.9H512.96V132.76h15.429v25.708Z",
    transform: "translate(8.669 -48.702)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M577.825,134.726v15.429H536.7V109.03h15.429v25.7Z",
    transform: "translate(12.784 -52.816)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M601.567,111v15.429H560.43V85.29h15.429V111Z",
    transform: "translate(16.897 -56.931)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M315.262,268.412A26.815,26.815,0,1,1,277.34,230.49Z",
    transform: "translate(46.711 39.952)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M206.477,104.072c-4.306,7.521-12.367,7.662-18.421,2.347-2.793-2.464-5.28-5.362-8.835-6.758a13.869,13.869,0,0,0-10.337.094c-4.365,1.807-6.172,5.679-9.387,8.823-2.663,2.617-6.594,4.482-10.29,2.558-2.5-1.314-3.59-4.353-5.444-6.336a13.916,13.916,0,0,0-8.378-4.224c-7.193-.939-12.989,3.755-15.382,10.243-1,2.71,3.321,3.872,4.306,1.173,2.523-6.864,10.889-9.668,16.3-4.06,2.933,3.051,4,6.465,8.331,7.873,7.65,2.487,12.578-3.215,17.119-8.213,10.185-11.311,16.239,3.039,25.438,6.289,7.509,2.652,15.007-.892,18.832-7.556C211.768,103.826,207.908,101.573,206.477,104.072Z",
    transform: "translate(20.775 17.109)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M206.477,117.961c-4.306,7.521-12.367,7.662-18.421,2.347-2.793-2.452-5.28-5.35-8.835-6.747a13.869,13.869,0,0,0-10.337.094c-4.365,1.8-6.172,5.679-9.387,8.812-2.663,2.617-6.594,4.494-10.29,2.558-2.5-1.3-3.59-4.353-5.444-6.324a14,14,0,0,0-8.378-4.236c-7.193-.927-12.989,3.766-15.382,10.255-1,2.7,3.321,3.872,4.306,1.173,2.523-6.852,10.889-9.657,16.3-4.048,2.933,3.051,4,6.465,8.331,7.873,7.65,2.487,12.578-3.215,17.119-8.213,10.185-11.311,16.239,3.039,25.438,6.277,7.509,2.652,15.007-.88,18.832-7.545C211.768,117.761,207.908,115.415,206.477,117.961Z",
    transform: "translate(20.775 19.519)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(271.993 35.911)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-235.748 22.752)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "o",
    width: 156.824,
    height: 127.958,
    transform: "translate(120.781 176.124) rotate(-66.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M435.82,250.067H406.129a8.1,8.1,0,0,0-7.917-6.386h-25.19a12.536,12.536,0,0,0-23.516,0h-25.19a8.1,8.1,0,0,0-7.886,6.386H286.708a5.381,5.381,0,0,0-5.468,5.288v193.18A5.468,5.468,0,0,0,286.708,454H435.82a5.474,5.474,0,0,0,5.475-5.468V255.374a5.388,5.388,0,0,0-5.474-5.307Z",
    transform: "translate(-254.523 -232.342)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "p",
    width: 156.824,
    height: 127.958,
    transform: "translate(116.14 168.922) rotate(-66.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M618,358.83a1.172,1.172,0,0,1-1.562.49L538.207,325.7a1.079,1.079,0,1,1,.818-1.984l78.229,33.64A1.166,1.166,0,0,1,618,358.83Z",
    transform: "translate(-351.881 -265.821)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M587.912,352.7a1.166,1.166,0,0,1-1.562.49l-50.634-21.774a1.079,1.079,0,1,1,.843-1.959l50.634,21.774a1.172,1.172,0,0,1,.719,1.469Z",
    transform: "translate(-350.921 -267.989)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M572.732,353.109a1.165,1.165,0,0,1-1.562.49L533.2,337.269a1.079,1.079,0,1,1,.843-1.959l37.974,16.33A1.165,1.165,0,0,1,572.732,353.109Z",
    transform: "translate(-349.964 -270.212)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M605.727,387.3a1.165,1.165,0,0,1-1.562.49l-78.229-33.64a1.079,1.079,0,1,1,.843-1.959l78.248,33.64a1.165,1.165,0,0,1,.7,1.469Z",
    transform: "translate(-347.205 -276.627)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M575.677,381.193a1.172,1.172,0,0,1-1.562.5l-50.609-21.78a1.079,1.079,0,1,1,.843-1.959l50.615,21.774A1.172,1.172,0,0,1,575.677,381.193Z",
    transform: "translate(-346.281 -278.816)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M560.482,381.6a1.166,1.166,0,0,1-1.562.49l-37.974-16.33a1.079,1.079,0,1,1,.843-1.959l37.974,16.33A1.172,1.172,0,0,1,560.482,381.6Z",
    transform: "translate(-345.309 -281.039)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M591.512,420.386a1.16,1.16,0,0,1-1.556.49l-78.229-33.634a1.079,1.079,0,1,1,.843-1.965l78.229,33.64A1.159,1.159,0,0,1,591.512,420.386Z",
    transform: "translate(-341.812 -289.205)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M561.443,414.286a1.166,1.166,0,0,1-1.556.49L509.247,393a1.079,1.079,0,1,1,.843-1.965l50.64,21.774A1.165,1.165,0,0,1,561.443,414.286Z",
    transform: "translate(-340.87 -291.394)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M546.283,414.686a1.166,1.166,0,0,1-1.556.5l-37.98-16.33a1.079,1.079,0,1,1,.843-1.965l37.98,16.33A1.166,1.166,0,0,1,546.283,414.686Z",
    transform: "translate(-339.92 -293.617)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M560.521,492.429a1.166,1.166,0,0,1-1.556.49l-78.229-33.64a1.079,1.079,0,1,1,.843-1.959l78.229,33.64A1.159,1.159,0,0,1,560.521,492.429Z",
    transform: "translate(-330.028 -316.578)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M530.452,486.323a1.159,1.159,0,0,1-1.556.49l-50.64-21.774a1.079,1.079,0,1,1,.843-1.959l50.64,21.774a1.159,1.159,0,0,1,.713,1.469Z",
    transform: "translate(-329.086 -318.767)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M515.272,486.729a1.159,1.159,0,0,1-1.556.49l-37.98-16.33a1.079,1.079,0,1,1,.843-1.959l37.98,16.33A1.159,1.159,0,0,1,515.272,486.729Z",
    transform: "translate(-328.128 -320.99)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M579.357,448.619a1.166,1.166,0,0,1-1.562.49l-78.229-33.64a1.079,1.079,0,1,1,.843-1.959l78.229,33.64a1.159,1.159,0,0,1,.719,1.469Z",
    transform: "translate(-337.184 -299.929)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M549.292,442.513a1.166,1.166,0,0,1-1.562.49L497.1,421.229a1.079,1.079,0,1,1,.843-1.959l50.634,21.774A1.166,1.166,0,0,1,549.292,442.513Z",
    transform: "translate(-336.245 -302.118)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M541.519,460.656a1.172,1.172,0,0,1-1.562.49l-50.64-21.774a1.079,1.079,0,1,1,.843-1.965l50.64,21.78A1.166,1.166,0,0,1,541.519,460.656Z",
    transform: "translate(-333.296 -309.015)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M534.112,442.919a1.166,1.166,0,0,1-1.562.49l-37.974-16.33a1.079,1.079,0,1,1,.843-1.959l37.974,16.33A1.166,1.166,0,0,1,534.112,442.919Z",
    transform: "translate(-335.287 -304.341)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M524.6,446.112a1.166,1.166,0,0,1-1.556.5l-31.1-13.379a1.079,1.079,0,1,1,.843-1.959l31.129,13.373A1.159,1.159,0,0,1,524.6,446.112Z",
    transform: "translate(-334.284 -306.679)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M648.882,392.074a.459.459,0,0,1-.453-.36l-1.358-5.7a.465.465,0,0,1,.273-.539.441.441,0,0,1,.18-.031.465.465,0,0,1,.4.223l2.015,3.311,7.44-2.48a.418.418,0,0,1,.149,0,.465.465,0,0,1,.428.279.471.471,0,0,1-.2.62l-8.618,4.7A.458.458,0,0,1,648.882,392.074Z",
    transform: "translate(-393.54 -289.324)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M647.242,385.616l2.207,3.627,7.768-2.623-8.624,4.7-1.358-5.7m9.976,1h0m-9.982-1.941a.91.91,0,0,0-.36.074.93.93,0,0,0-.546,1.073l1.358,5.71a.948.948,0,0,0,.527.62.924.924,0,0,0,.378.081.936.936,0,0,0,.446-.112l8.593-4.693a.917.917,0,0,0,.508-.825.93.93,0,0,0-.88-.93h-.186a.855.855,0,0,0-.18.05l-7.055,2.4-1.817-2.995a.936.936,0,0,0-.794-.453Z",
    transform: "translate(-393.252 -289.036)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M592.319,523.647a.461.461,0,0,1-.452-.354l-1.364-5.71a.471.471,0,0,1,.279-.539.427.427,0,0,1,.174,0,.459.459,0,0,1,.4.223l2.015,3.311,7.44-2.48a.418.418,0,0,1,.149,0,.465.465,0,0,1,.223.874l-8.618,4.7A.46.46,0,0,1,592.319,523.647Z",
    transform: "translate(-372.044 -339.333)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M590.67,517.191l2.207,3.627,7.775-2.623-8.618,4.731-1.364-5.7m9.982,1h0m-9.982-1.934a.891.891,0,0,0-.353.068.93.93,0,0,0-.552,1.073l1.364,5.71a.93.93,0,0,0,.527.62.905.905,0,0,0,.378.081.936.936,0,0,0,.446-.112l8.581-4.706a.93.93,0,0,0-.378-1.761h-.18a.871.871,0,0,0-.18.05l-7.049,2.381-1.81-2.97a.918.918,0,0,0-.794-.446Z",
    transform: "translate(-371.758 -339.046)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M621.689,455.334a.478.478,0,0,1-.186-.037.483.483,0,0,1-.267-.316l-1.364-5.71a.471.471,0,0,1,.279-.539.427.427,0,0,1,.174-.031.459.459,0,0,1,.4.223l2.015,3.311,7.44-2.48a.415.415,0,0,1,.149,0,.465.465,0,0,1,.223.874l-8.618,4.7A.477.477,0,0,1,621.689,455.334Z",
    transform: "translate(-383.205 -313.364)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M620.04,448.888l2.207,3.627,7.775-2.623-8.618,4.7-1.364-5.7m9.982,1h0m-9.982-1.9a.89.89,0,0,0-.353.068.93.93,0,0,0-.552,1.073l1.364,5.71a.93.93,0,0,0,.527.62.906.906,0,0,0,.378.081.935.935,0,0,0,.446-.112l8.593-4.693a.918.918,0,0,0,.508-.825.93.93,0,0,0-.887-.93h-.18a.863.863,0,0,0-.18.05l-7.049,2.381-1.823-2.995a.917.917,0,0,0-.794-.446Z",
    transform: "translate(-382.919 -313.087)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "s",
    width: 160.055,
    height: 203.918,
    rx: 8.83,
    transform: "translate(23.549 14.575)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M436.2,445.618a5.382,5.382,0,0,1-5.475,5.288H281.644a5.382,5.382,0,0,1-5.474-5.288V259.2a5.382,5.382,0,0,1,5.474-5.282H430.75a5.381,5.381,0,0,1,5.474,5.282Z",
    transform: "translate(-252.596 -239.344)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "p",
    width: 141.467,
    height: 173.372,
    transform: "translate(32.843 25.586)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M90.1,30.547H0V16.287a8.112,8.112,0,0,1,8.1-8.1H33.27a12.564,12.564,0,0,1,23.551,0H82a8.112,8.112,0,0,1,8.1,8.1V30.546ZM45.048,4.866a3.85,3.85,0,1,0,3.85,3.85A3.855,3.855,0,0,0,45.048,4.866Z",
    transform: "translate(58.529 0)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "v",
    width: 90.102,
    height: 9.926,
    transform: "translate(58.529 20.62)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M420.026,331.572a1.24,1.24,0,0,1-1.24,1.178h-94.4a1.184,1.184,0,1,1,0-2.362h94.4A1.24,1.24,0,0,1,420.026,331.572Z",
    transform: "translate(-270.435 -268.403)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M386.82,338.5a1.24,1.24,0,0,1-1.24,1.178h-61.2a1.184,1.184,0,1,1,0-2.362h61.2A1.24,1.24,0,0,1,386.82,338.5Z",
    transform: "translate(-270.435 -271.036)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M371.637,345.548a1.24,1.24,0,0,1-1.24,1.178H324.438a1.178,1.178,0,1,1,0-2.356H370.4A1.24,1.24,0,0,1,371.637,345.548Z",
    transform: "translate(-270.491 -273.717)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "q",
    width: 76.946,
    height: 3.658,
    rx: 1.829,
    transform: "translate(73.303 91.087)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "q",
    width: 76.946,
    height: 3.658,
    rx: 1.829,
    transform: "translate(73.303 109.507)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "q",
    width: 76.946,
    height: 3.658,
    rx: 1.829,
    transform: "translate(73.303 128.255)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "q",
    width: 76.946,
    height: 3.658,
    rx: 1.829,
    transform: "translate(73.303 145.745)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "M336.08,368.727V380.2H324.617V368.727H336.08m1.463-1.457H323.16v14.4h14.4v-14.4Z",
    transform: "translate(-270.453 -282.42)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "M336.08,398.827v11.482H324.617V398.827H336.08m1.463-1.457H323.16v14.4h14.4v-14.4Z",
    transform: "translate(-270.453 -293.858)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "M336.08,428.9v11.482H324.617V428.9H336.08m1.463-1.457H323.16v14.4h14.4v-14.4Z",
    transform: "translate(-270.453 -305.285)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "M336.08,459.347v11.482H324.617V459.347H336.08m1.463-1.457H323.16v14.4h14.4v-14.4Z",
    transform: "translate(-270.453 -316.857)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M331.689,378.245a.452.452,0,0,1-.366-.186l-4.749-6.367a.465.465,0,0,1,.62-.657l4.383,3.1,7.979-7.167a.452.452,0,0,1,.31-.118.465.465,0,0,1,.366.75l-8.171,10.5a.459.459,0,0,1-.366.174Z",
    transform: "translate(-271.722 -282.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M339.6,367.045h0m0,0-8.2,10.447-4.743-6.361,4.681,3.329,8.258-7.44m0-.93h0a.893.893,0,0,0-.62.242l-7.706,6.913-4.073-2.871a.967.967,0,0,0-.539-.167.93.93,0,0,0-.75,1.482l4.749,6.367a.911.911,0,0,0,.732.372h0a.936.936,0,0,0,.732-.353l8.178-10.422a.936.936,0,0,0-.707-1.531Z",
    transform: "translate(-271.429 -281.971)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M331.673,406a.471.471,0,0,1-.366-.186l-4.749-6.367a.48.48,0,0,1,.663-.676l4.383,3.1,7.979-7.173a.484.484,0,0,1,.31-.118.459.459,0,0,1,.316.124.471.471,0,0,1,.05.62l-8.2,10.447a.465.465,0,0,1-.366.18Z",
    transform: "translate(-271.706 -292.798)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M339.579,394.8h0m0,0-8.2,10.453-4.743-6.342,4.681,3.336,8.258-7.44m0-.93h0a.923.923,0,0,0-.62.242l-7.706,6.919-4.073-2.9a.942.942,0,0,0-1.321,1.314l4.749,6.361a.917.917,0,0,0,.732.378h0a.924.924,0,0,0,.732-.36l8.178-10.422a.936.936,0,0,0-.707-1.531Z",
    transform: "translate(-271.409 -292.532)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M291.12,482.72v42.332h20.6C310.811,525.052,292.366,503.973,291.12,482.72Z",
    transform: "translate(-258.277 -326.293)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M314.343,503.228a37.755,37.755,0,0,1-13.943-7.173,25.42,25.42,0,0,1-9.3-18.085v2.771c1.24,21.272,19.691,42.525,20.6,42.518A6.82,6.82,0,0,1,310.282,519C310.183,515.082,312.285,509.713,314.343,503.228Z",
    transform: "translate(-258.27 -324.488)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M251.242,517.6l-13.931,6.652h0L162.8,599.063h0l-4.854,4.861.037.037-1.823,1.86a7.192,7.192,0,1,0,10.18,10.161l1.817-1.823.043.037,4.867-4.879h0l74.516-74.832h0l6.708-13.844v.031l2.988-6.163-6.2,2.957Z",
    transform: "translate(-151.742 -396.878)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M162.6,657.148a7.186,7.186,0,0,1-10.168,0h0a7.186,7.186,0,0,1,0-10.168L162.4,637a7.186,7.186,0,0,1,10.168,0h0a7.186,7.186,0,0,1,0,10.168Z",
    transform: "translate(-150.321 -442.625)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ab",
    width: 6.894,
    height: 14.489,
    transform: "matrix(0.707, -0.708, 0.708, 0.707, 3.884, 202.495)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ac",
    d: "M284.6,517.095l10.248,10.236,9.542-19.691Z",
    transform: "translate(-201.349 -394.267)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M313.04,507.15l-6.2,2.964,3.211,3.205Z",
    transform: "translate(-209.801 -394.081)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "x",
    width: 105.589,
    height: 14.495,
    transform: "translate(8.723 197.659) rotate(-45.11)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ad",
    width: 105.589,
    height: 6.355,
    transform: "translate(11.605 200.529) rotate(-45.11)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M321.77,534.56v.05",
    transform: "translate(-269.925 -345.993)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartExam);
export default __webpack_public_path__ + "static/media/startExam.c59d21982cd3e9b8917c4b6e672a705a.svg";
export { ForwardRef as ReactComponent };